import MenuItem from "../entity/MenuItem";

const zh_CN = {

    APP_BRAND: "工业及仓储管理",

    COMMON_BUTTON_OK: "确定",
    COMMON_BUTTON_ADD: "添加",
    COMMON_BUTTON_BATCH_ADD: "批量添加",
    COMMON_BUTTON_CREATE: "创建",
    COMMON_BUTTON_UPDATE: "更新",
    COMMON_BUTTON_SAVE: "保存",
    COMMON_BUTTON_SAVE_DRAFT: "保存草稿",
    COMMON_BUTTON_MODIFY: "修改",
    COMMON_BUTTON_EDIT: "编辑",
    COMMON_BUTTON_REMOVE: "移除",
    COMMON_BUTTON_DELETE: "删除",
    COMMON_BUTTON_SUBMIT: "提交",
    COMMON_BUTTON_CANCEL: "取消",
    COMMON_BUTTON_SEARCH: "查询",
    COMMON_BUTTON_DOWNLOAD_ORIGINAL_IMAGE: "下载原图",

    COMMON_BUTTON_SAVEANDCLOSE: "保存并关闭",
    COMMON_BUTTON_SEARCH_CLEAR: "清空查询",
    COMMON_BUTTON_SEARCH_ADVANCE: "高级查询",
    COMMON_BUTTON_DRAFT: "保存草稿",
    COMMON_BUTTON_EXPORT: "导出",
    COMMON_BUTTON_SELECT: "选择",
    COMMON_BUTTON_SELECTED: "已选择",
    COMMON_BUTTON_BACK: "返回",
    COMMON_BUTTON_UPLOAD: "上传",
    COMMON_BUTTON_UPLOAD_AGAIN: "重新上传",
    COMMON_BUTTON_SCAN: "扫描",
    COMMON_BUTTON_STOP: "停止",
    COMMON_BUTTON_REFRESH: "刷新",
    COMMON_BUTTON_DETAIL: "详细",
    COMMON_BUTTON_CLOSE: "关闭",
    COMMON_BUTTON_COPY: "复制",
    COMMON_BUTTON_NEW: "新建",
    COMMON_BUTTON_COMPARE: "比较",
    COMMON_BUTTON_PREVIEW: "预览",
    COMMON_BUTTON_PRINT: "打印",
    COMMON_FIELD_UPDATE_TIME: "更新时间",
    COMMON_FIELD_REMARKS: "备注",
    COMMON_FIELD_REMARKS_PLACEHOLDER: "请输入备注",
    COMMON_FIELD_ENABLED: "有效",
    COMMON_FIELD_DISABLED: "无效",
    COMMON_FIELD_ACTION: "操作",
    COMMON_FIELD_HAVE: "有",
    COMMON_FIELD_NOTHING: "无",
    COMMON_FIELD_PAGINATION_TOTAL: "共 {sum} 条",
    COMMON_FIELD_HEIGHT: "高",
    COMMON_FIELD_WIDTH: "宽",
    COMMON_FIELD_DEEP: "深",
    COMMON_FIELD_FLOOR: "层",
    COMMON_FIELD_NUMBER: "序号",
    COMMON_FIELD_UNIT_M: "米",
    COMMON_FIELD_UNIT_M2: "平方米",
    COMMON_FIELD_UNIT_T_M2: "吨/平方米",
    COMMON_PLACEHOLDER_FUZZY_QUERY: "模糊查询",
    COMMON_PLACEHOLDER_SELECT_DATE: "选择日期",
    COMMON_FIELD_CREATE_TIME: "创建时间",
    COMMON_FIELD_CREATE_USER: "创建用户",

    // COMMON_MSG_EXIST_DATA: "您已经加入此方案。",
    COMMON_MSG_UPLOAD_CONTINUE: "上传中，请稍后。。。",
    COMMON_MSG_IMPORT_CONTINUE: "导入中，请稍后。。。",
    COMMON_MSG_CREATE_SUCCESS: "创建已完成",
    COMMON_MSG_UPDATE_SUCCESS: "更新已完成",
    COMMON_MSG_DELETE_SUCCESS: "删除已完成",
    COMMON_MSG_EXPORT_FAILURE: "导出失败，请确认是否正确填写条件？",
    COMMON_MSG_DELETE_TITLE: "删除确认",
    COMMON_MSG_UPDATE_TITLE: "修改确认",
    COMMON_MSG_WARNING_TITLE: "警告",
    COMMON_MSG_WARNING_CONFIRM: "未设置主图，请确认房源照片内是否设置主图？",
    COMMON_MSG_DELETE_CONFIRM: "删除后无法恢复，请确认是否删除？",
    COMMON_MSG_UPDATE_CONFIRM: "是否修改主联系人，请确认？",
    COMMON_MSG_REQUIRED: "不能为空",
    COMMON_MSG_BOTH_CHOOSE: "两项必填一项",
    COMMON_MSG_UNEXPECTED_EXCEPTION: "未处理异常，请联系管理员",
    COMMON_MSG_CREATE_FAVORITES: "收藏成功",
    COMMON_MSG_SUPERVISOR_EVALUATION: "打分成功",
    COMMON_FIELD_VALUE_UNKNOWN: "不详",
    COMMON_FIELD_VALUE_NO_LIMIT: "不限",
    COMMON_MSG_AREA_COMPARISON: "建筑面积必须大于空置面积",
    COMMON_MSG_FILL_AGAIN: "请重新确认",


    // 账户管理-角色
    ACCOUNT_ROLE_FIELD_NAME: "角色",

    ACCOUNT_USER_ROUTE_LOGIN_PASSWORD: "密码登录",
    ACCOUNT_USER_ROUTE_LOGOUT: "退出登录",
    ACCOUNT_USER_ROUTE_REGISTER: "用户注册",
    ACCOUNT_USER_ROUTE_LIST: "用户一览",
    ACCOUNT_USER_ROUTE_CENTER: "个人中心",
    ACCOUNT_USER_ROUTE_PROFILE: "基本信息",
    ACCOUNT_USER_ROUTE_PASSWORD: "用户密码",
    ACCOUNT_USER_ROUTE_PASSWORD_MODIFY: "修改密码",
    ACCOUNT_USER_ROUTE_PASSWORD_FORGOT: "忘记密码",

    ACCOUNT_USER_TITLE_CREATE: "创建新用户",
    ACCOUNT_USER_TITLE_UPDATE: "更新用户",
    ACCOUNT_USER_TITLE_DELETE: "删除用户",
    ACCOUNT_USER_TITLE_PASSWORD_RESET: "密码重制",
    ACCOUNT_USER_TITLE_WX_QR_CODE: "微信二维码",
    ACCOUNT_USER_FIELD_UID: "用户ID",
    ACCOUNT_USER_FIELD_UID_PLACEHOLDER: "用户ID/邮箱/手机号",
    ACCOUNT_USER_FIELD_PASSWORD_OLD: "旧密码",
    ACCOUNT_USER_FIELD_PASSWORD: "密码",
    ACCOUNT_USER_FIELD_PASSWORD_CONFIRM: "确认密码",
    ACCOUNT_USER_FIELD_EMAIL: "邮箱",
    ACCOUNT_USER_FIELD_EMAIL_VERIFY_CODE: "邮箱验证码",
    ACCOUNT_USER_FIELD_MOBILE: "手机号",
    ACCOUNT_USER_FIELD_FIRST_NAME: "名",
    ACCOUNT_USER_FIELD_LAST_NAME: "姓",
    ACCOUNT_USER_FIELD_FULL_NAME: "姓名",
    ACCOUNT_USER_FIELD_ROLE: "角色",
    ACCOUNT_USER_FIELD_ENABLE: "有效性",
    ACCOUNT_USER_FIELD_PORTRAIT: "头像",
    ACCOUNT_USER_FIELD_WX_STATUS: "微信状态",
    ACCOUNT_USER_FIELD_WX_STATUS_Y: "已绑定",
    ACCOUNT_USER_FIELD_WX_STATUS_N: "未绑定",
    ACCOUNT_USER_BUTTON_SUBMIT: "登录",
    ACCOUNT_USER_BUTTON_REGISTER: "注册新用户",
    ACCOUNT_USER_BUTTON_EMAIL_VERIFY_CODE: "发送验证码",
    ACCOUNT_USER_BUTTON_PASSWORD_RESET: "重置密码",
    ACCOUNT_USER_MSG_UID_REQUIRED: "用户ID是不能为空",
    ACCOUNT_USER_MSG_PASSWORD_REQUIRED: "密码不能为空",
    ACCOUNT_USER_MSG_PASSWORD_WRONG: "密码错误",
    ACCOUNT_USER_MSG_OLD_PASSWORD_REQUIRED: "旧密码不能为空",
    ACCOUNT_USER_MSG_OLD_PASSWORD_WRONG: "旧密码错误",
    ACCOUNT_USER_MSG_PASSWORD_LENGTH_REQUIRED: "密码长度不能少于{value}个字符",
    ACCOUNT_USER_MSG_PASSWORD_STRENGTH_REQUIRED: "密码必须包含字符，数字，特殊符号的组合",
    ACCOUNT_USER_MSG_PASSWORD_CONFIRM_REQUIRED: "密码确认不能为空",
    ACCOUNT_USER_MSG_PASSWORD_CONFIRM_EQUAL_REQUIRED: "两次密码不一致",
    ACCOUNT_USER_MSG_MOBILE_REQUIRED: "手机号不能为空",
    ACCOUNT_USER_MSG_MOBILE_FORMAT_WRONG: "手机号格式不正确",
    ACCOUNT_USER_MSG_EMAIL_REQUIRED: "邮箱不能为空",
    ACCOUNT_USER_MSG_EMAIL_FORMAT_WRONG: "邮箱格式不正确",
    ACCOUNT_USER_MSG_EMAIL_CODE_REQUIRED: "邮箱验证码不能为空",
    ACCOUNT_USER_MSG_EMAIL_CODE_SEND_SUCCESS: "邮箱验证码发送成功",
    ACCOUNT_USER_MSG_EMAIL_CODE_NOT_FOUND: "邮箱验证码不正确",
    ACCOUNT_USER_MSG_LAST_NAME_REQUIRED: "姓不能为空",
    ACCOUNT_USER_MSG_FIRST_NAME_REQUIRED: "名不能为空",
    ACCOUNT_USER_MSG_ROLE_REQUIRED: "角色不能为空",
    ACCOUNT_USER_MSG_AUTH_TOKEN_EXPIRED: "登录令牌过期",
    ACCOUNT_USER_MSG_AUTH_TOKEN_NON_PRINCIPAL: "登录令牌不存在",
    ACCOUNT_USER_MSG_PASSWORD_RESET_SUCCESS: "密码重制成功",
    ACCOUNT_USER_MSG_PASSWORD_RESET_CONFIRM: "确定要重制该用户的密码吗？",
    ACCOUNT_USER_MSG_CREATE_SUCCESS: "用户创建成功",
    ACCOUNT_USER_MSG_UPDATE_SUCCESS: "用户更新成功",
    ACCOUNT_USER_MSG_DELETE_SUCCESS: "用户删除成功",
    ACCOUNT_USER_MSG_DELETE_CONFIRM: "用户删除确认吗？",
    ACCOUNT_USER_MSG_NOT_FOUND: "该用户不存在",
    ACCOUNT_USER_MSG_DISABLED: "该用户未激活",
    ACCOUNT_USER_MSG_WX_OPEN_ID_SUCCESS: "微信绑定成功",

    ACCOUNT_APP_MSG_ACCESS_FORBIDDEN: "该应用禁止访问",
    ACCOUNT_APP_MSG_ACCESS_NOT_FOUND: "该应用未正确注册",
    ACCOUNT_APP_MSG_ACCESS_DISABLED: "该应用未激活",

    // 组织管理-组织
    ORG_ROUTER_MANAGEMENT: "组织管理",
    ORG_ORGANIZATION_ROUTE_LIST: "组织一览",
    ORG_ORGANIZATION_TITLE_CREATE: "创建新组织",
    ORG_ORGANIZATION_TITLE_UPDATE: "更新组织",
    ORG_ORGANIZATION_TITLE_DELETE: "删除组织",
    ORG_ORGANIZATION_FIELD_PARENT: "上级组织",
    ORG_ORGANIZATION_FIELD_CODE: "编号",
    ORG_ORGANIZATION_FIELD_NAME: "名称",
    ORG_ORGANIZATION_FIELD_TYPE: "类型",
    ORG_ORGANIZATION_FIELD_TYPE_GROUP: "总部",
    ORG_ORGANIZATION_FIELD_TYPE_SUB_CENTER: "分部",
    ORG_ORGANIZATION_FIELD_TYPE_PROPERTY_COMPANY: "物业公司",
    ORG_ORGANIZATION_FIELD_TYPE_COMMUNITY: "管理小区",
    ORG_ORGANIZATION_FIELD_TYPE_MANAGE_SECTION: "管养段",
    ORG_ORGANIZATION_FIELD_TYPE_RESIDENT: "居民",
    ORG_ORGANIZATION_FIELD_TYPE_REPAIRMAN: "维修员",
    ORG_ORGANIZATION_FIELD_TYPE_COMPANY: "第三方维修单位",
    ORG_ORGANIZATION_FIELD_TYPE_REPAIR_UNIT: "维保公司",
    ORG_ORGANIZATION_FIELD_TYPE_EMPLOYEE: "工作人员",
    ORG_ORGANIZATION_FIELD_CONTACTS: "联系人",
    ORG_ORGANIZATION_FIELD_TELEPHONE: "联系电话",
    ORG_ORGANIZATION_FIELD_ADDRESS: "联系地址",
    ORG_ORGANIZATION_MSG_CODE_REQUIRED: "组织编号不能为空",
    ORG_ORGANIZATION_MSG_NAME_REQUIRED: "组织名不能为空",
    ORG_ORGANIZATION_MSG_TYPE_REQUIRED: "组织类型不能为空",
    ORG_ORGANIZATION_MSG_CREATE_SUCCESS: "组织创建成功",
    ORG_ORGANIZATION_MSG_UPDATE_SUCCESS: "组织更新成功",
    ORG_ORGANIZATION_MSG_DELETE_SUCCESS: "组织删除成功",
    ORG_ORGANIZATION_MSG_DELETE_CONFIRM: "组织删除确认吗？",
    ORG_ORGANIZATION_MSG_PARENT_DEAD_CYCLE: "不可设置父组织为自己",
    // 组织管理-员工
    ORG_EMPLOYEE_ROUTE_LIST: "系统用户",
    ORG_EMPLOYEE_TITLE_CREATE: "员工创建",
    ORG_EMPLOYEE_TITLE_UPDATE: "员工更新",
    ORG_EMPLOYEE_TITLE_DELETE: "员工删除",
    ORG_EMPLOYEE_FIELD_CODE: "工号",
    ORG_EMPLOYEE_FIELD_FULL_NAME: "姓名",
    ORG_EMPLOYEE_FIELD_MOBILE: "手机号",

    ORG_EMPLOYEE_FIELD_ORGANIZATION: "组织",
    ORG_EMPLOYEE_FIELD_ORGANIZATION_PARENT: "上级组织",
    ORG_EMPLOYEE_FIELD_LAST_NAME: "姓",
    ORG_EMPLOYEE_FIELD_FIRST_NAME: "名",
    ORG_EMPLOYEE_FIELD_EMAIL: "邮箱",
    ORG_EMPLOYEE_FIELD_EMAIL_PASSWORD: "邮箱密码",
    ORG_EMPLOYEE_FIELD_ENTRY_DATE: "入职时间",
    ORG_EMPLOYEE_CONTRACT_TITLE_DELETE: "员工薪酬信息删除",

    ORG_EMPLOYEE_CONTRACT_FIELD_BASE_SALARY: "基本工资",
    ORG_EMPLOYEE_CONTRACT_FIELD_START_DATE: "开始时间",
    ORG_EMPLOYEE_CONTRACT_FIELD_END_DATE: "结束时间",
    ORG_EMPLOYEE_CONTRACT_TITLE_CREATE: "员工薪酬创建",
    ORG_EMPLOYEE_CONTRACT_TITLE_UPDATE: "员工薪酬更新",

    ORG_EMPLOYEE_FIELD_EMAIL_VERIFY_CODE: "Verify Code",
    ORG_EMPLOYEE_BUTTON_SEND_VERIFY_EMAIL_CODE: "Send verify code",
    ORG_EMPLOYEE_BUTTON_REGISTER: "Register",
    ORG_EMPLOYEE_MSG_ORGANIZATION_ID_REQUIRED: "员工所属组织是必填项。",
    ORG_EMPLOYEE_MSG_LAST_NAME_REQUIRED: "员工姓氏是必填项",
    ORG_EMPLOYEE_MSG_FIRST_NAME_REQUIRED: "员工名字是必填项",
    ORG_EMPLOYEE_MSG_CODE_REQUIRED: "员工号是必填项。",
    ORG_EMPLOYEE_MSG_EMAIL_REQUIRED: "员工邮箱是必填项。",
    ORG_EMPLOYEE_MSG_EMAIL_DUPLICATE: "员工邮箱重复。",
    ORG_EMPLOYEE_MSG_EMAIL_FORMAT_WRONG: "员工邮箱格式错误。",
    ORG_EMPLOYEE_MSG_MOBILE_REQUIRED: "员工手机号是必填项。",
    ORG_EMPLOYEE_MSG_MOBILE_FORMAT_WRONG: "员工手机号格式错误",
    ORG_EMPLOYEE_MSG_REGISTER_SUCCESS: "注册成功",
    ORG_EMPLOYEE_MSG_CREATE_SUCCESS: "员工创建成功",
    ORG_EMPLOYEE_MSG_UPDATE_SUCCESS: "员工更新成功",
    ORG_EMPLOYEE_MSG_DELETE_SUCCESS: "员工删除成功",
    ORG_EMPLOYEE_MSG_DELETE_CONFIRM: "员工删除确认吗？",

    // 文件管理
    FTP_FILE_ROUTE_LIST: "文件一览",
    FTP_FILE_FIELD_NAME: "文件名",
    FTP_FILE_FIELD_PATH: "文件路径",
    FTP_FILE_FIELD_LAST_MODIFIED: "最后修改日期",
    FTP_MSG_UPLOAD_SUCCEED: "上传成功",
    FTP_MSG_UPLOAD_FAILED: "上传失败",

    //房源筛选显示的标签
    WMS_ZONE_ROUTE_ACCEPT_RENT: "接受短租",
    WMS_ZONE_ROUTE_PRIVATE_HOUSE: "独门独院",
    WMS_ZONE_ROUTE_PLENTY_POWER: "电量充足",
    WMS_ZONE_ROUTE_EXPRESS_DISTRIBUTION: "快递分拨",
    WMS_ZONE_ROUTE_RETURNABLE_COLD_STORAGE: "可改冷库",
    WMS_ZONE_ROUTE_COMPULSORY_REGISTRATION: "强制注册",
    WMS_ZONE_ROUTE_LIMITED_TIME_SPECIAL: "限时特价",
    WMS_ZONE_ROUTE_NEW_ON_THE_7TH: "7日上新",
    WMS_ZONE_ROUTE_LATEST_TRANSACTION: "最新成交",

    //房源照片标签
    WMS_ZONE_ROUTE_PHOTO_AERIAL_VIEW: "鸟瞰图",
    WMS_ZONE_ROUTE_PHOTO_RENDERING_VIEW: "效果图",
    WMS_ZONE_ROUTE_PHOTO_EXTERNAL_VIEW: "房屋外部照片",
    WMS_ZONE_ROUTE_PHOTO_EXTERNAL_FACADE_VIEW: "外部正面图",//废弃
    WMS_ZONE_ROUTE_PHOTO_EXTERNAL_PROFILE_VIEW: "外部侧面图",//废弃

    WMS_ZONE_ROUTE_PHOTO_INTERNAL_VIEW: "房屋内部照片",
    WMS_ZONE_ROUTE_PHOTO_INTERNAL_LENGTH_AXIS_VIEW: "内部长轴图",//废弃
    WMS_ZONE_ROUTE_PHOTO_INTERNAL_SHORT_AXIS_VIEW: "内部短轴图",//废弃
    WMS_ZONE_ROUTE_PHOTO_INTERIOR_DIAGONAL_VIEW: "内部对角图",//废弃

    WMS_ZONE_ROUTE_PHOTO_FIRE_PROTECTION_SYSTEM: "消防系统",
    WMS_ZONE_ROUTE_PHOTO_LIFT_PLATFORM: "升降平台",
    WMS_ZONE_ROUTE_PHOTO_FLOW_FIELD: "周转场地",
    WMS_ZONE_ROUTE_PHOTO_SUPPORTING_FACILITIES: "配套设施",
    WMS_ZONE_ROUTE_PHOTO_LIFT_UP_DOOR: "提升门",
    WMS_ZONE_ROUTE_PHOTO_FORKLIFT_RAMP: "叉车坡道",
    WMS_ZONE_ROUTE_PHOTO_OFFICE: "办公室",
    WMS_ZONE_ROUTE_PHOTO_CARGO_LIFT: "货梯",
    WMS_ZONE_ROUTE_PHOTO_RAMP: "坡道",
    WMS_ZONE_ROUTE_LOCATION: "项目位置",

//房源文件标签
    WMS_ZONE_FILE_TAG_LAND_CERTIFICATE: "土地证",
    WMS_ZONE_FILE_TAG_FIRE_CHECK_REPORT: "消防验收意见书",
    WMS_ZONE_FILE_TAG_PROJECT_PLAN_CERTIFICATE: "工程规划许可证",
    WMS_ZONE_FILE_TAG_PROJECT_WORK_CERTIFICATE: "工程施工许可证",
    WMS_ZONE_FILE_TAG_PROJECT_END_REPORT: "竣工验收备案",
    WMS_ZONE_FILE_TAG_HOUSE_CERTIFICATE: "房产证",
    WMS_ZONE_FILE_TAG_ZONE_TOTAL_VIEW: "项目总平面图",
    WMS_ZONE_FILE_TAG_ZONE_HORIZONTAL_VERTICAL_VIEW: "房屋平立剖",
    WMS_ZONE_FILE_TAG_CAD_DRAWINGS: "CAD图纸",
    WMS_ZONE_FILE_TAG_PROJECT_INTRODUCTION: "项目介绍",
    WMS_ZONE_FILE_TAG_BUSINESS_LICENSE: "营业执照",
    WMS_ZONE_FILE_TAG_RENT_AREA_TABLE: "计租面积明细表",
    // 房源管理
    WMS_ZONE_ROUTE_MANAGEMENT: "房源管理",
    WMS_ZONE_ROUTE_FILTER: "房源筛选",
    WMS_ZONE_ROUTE_LIST: "房源一览",
    WMS_ZONE_ROUTE_CREATE: "房源创建",
    WMS_ZONE_ROUTE_IMPORT: "房源导入",
    WMS_ZONE_ROUTE_FAVORITES: "我的收藏",
    WMS_ZONE_TITLE_CREATE_ZONE: "创建项目信息",
    WMS_ZONE_TITLE_UPDATE_ZONE: "更新项目信息",
    WMS_ZONE_TITLE_DETAILS_VERSION: "详情版",
    WMS_ZONE_TITLE_SIMPLE_VERSION: "简易版",
    WMS_ZONE_TITLE_DELETE: "项目信息删除",
    WMS_ZONE_TITLE_CREATE_BUILDING: "创建物业信息",
    WMS_ZONE_TITLE_UPDATE_BUILDING: "更新物业信息",
    WMS_ZONE_TITLE_CREATE_LEASE: "创建租约信息",
    WMS_ZONE_TITLE_UPDATE_LEASE: "更新租约信息",
    WMS_ZONE_TITLE_BASIC_INFO: "基础信息",
    WMS_ZONE_TITLE_SPECIFICATION: "规格信息",
    WMS_ZONE_TITLE_BUILDINGS: "物业管理",
    WMS_ZONE_TITLE_CONTACTS: "联系人",
    WMS_ZONE_TITLE_BUSINESS: "商务信息",
    WMS_ZONE_TITLE_LEASE: "租约管理",
    WMS_ZONE_TITLE_VACANT_AREA_FLOOR: "按楼层分",
    WMS_ZONE_TITLE_VACANT_AREA_SPECIFIC: "按物业规格分",
    WMS_ZONE_TITLE_ZONE_PICTURE_UPLOAD: "房源照片上传",
    WMS_ZONE_TITLE_ZONE_PICTURE_BATCH_ADD_UPLOAD: "房源照片批量上传",
    WMS_ZONE_FIELD_ZONE_DRAWINGS_AND_PHOTO_UPLOAD: "图纸及证照上传",
    WMS_ZONE_FIELD_ZONE_DRAWINGS_AND_PHOTO_BATCH_ADD_UPLOAD: "图纸及证照批量上传",
    WMS_ZONE_FIELD_ZONE_FOLLOWUP: "跟进记录",
    WMS_ZONE_BUTTON_CREATE_ZONE: "创建项目",
    WMS_ZONE_BUTTON_CREATE_BUILDING: "创建物业",
    WMS_ZONE_BUTTON_CREATE_LESSOR_COMPANY: "新建出租方公司",
    WMS_ZONE_BUTTON_SELECT_LESSOR_CONTACT: "选择联系人",
    WMS_ZONE_TITLE_SELECT_LESSOR_CONTACT: "选择联系人",
    WMS_ZONE_BUTTON_CREATE_LESSOR_CONTACT: "新建联系人",
    WMS_ZONE_BUTTON_LOCATION_PICK_UP: "拾点",
    WMS_ZONE_BUTTON_LOCATION_RAGE: "描边",
    WMS_ZONE_FIELD_FUZZY_PLACEHOLDER: "编号/项目名/品牌",
    WMS_ZONE_FIELD_HOLP_LIVE_DATE: "希望入驻时间",
    WMS_ZONE_FIELD_NUMBER: "房源编号",
    WMS_ZONE_FIELD_NUMBER_PLACEHOLDER: "房源编号自动生成",
    WMS_ZONE_FIELD_PROVINCE_CITY_DISTRICT: "省市行政区",

    WMS_ZONE_FIELD_PROVINCE: "省份",
    WMS_ZONE_FIELD_CITY: "城市",
    WMS_ZONE_FIELD_DISTRICT: "行政区",
    WMS_ZONE_FIELD_TOWN: "镇",
    WMS_ZONE_FIELD_NAME: "项目名称",
    WMS_ZONE_FIELD_BAIDU_MAP_ADDRESS: "百度地图地址",
    WMS_ZONE_FIELD_ADDRESS: "项目地址",
    WMS_ZONE_FIELD_LOCATION: "坐标",
    WMS_ZONE_FIELD_LOCATION_LOAD_AREA: "土地面积",
    WMS_ZONE_FIELD_LOCATION_BUILDING_AREA: "建筑面积",
    WMS_ZONE_FIELD_LONGITUDE: "经度",
    WMS_ZONE_FIELD_LATITUDE: "纬度",
    WMS_ZONE_FIELD_LOCATION_RANG: "坐标范围",
    WMS_ZONE_FIELD_LAND_AREA: "土地面积",
    WMS_ZONE_FIELD_PROPERTY_IN_LAND: "土地所有权",
    WMS_ZONE_FIELD_LAND_USE: "土地用途",
    WMS_ZONE_FIELD_STATE_OWNED_LAND: "国有用地",
    WMS_ZONE_FIELD_COLLECTIVE_LAND: "集体用地",
    WMS_ZONE_FIELD_PRODUCTION_LAND: "军产用地",
    WMS_ZONE_FIELD_INDUSTRIAL_LAND: "工业用地",
    WMS_ZONE_FIELD_WAREHOUSE_LAND: "仓储用地",
    WMS_ZONE_FIELD_LAND_AREA_UNKNOWN: "不详",
    WMS_ZONE_FIELD_PROPERTY_LEVEL: "物业等级",
    WMS_ZONE_FIELD_CLASS_A_WAREHOUSE: "A类仓库",
    WMS_ZONE_FIELD_CLASS_B_WAREHOUSE: "B类库房",
    WMS_ZONE_FIELD_CLASS_C_WORKSHOP: "C类厂房",
    WMS_ZONE_FIELD_BUILDING_AREA: "建筑面积",
    WMS_ZONE_FIELD_VACANT_AREA: "空置面积",
    WMS_ZONE_FIELD_VACANT_AREA_CURRENT: "当前空置",
    WMS_ZONE_FIELD_VACANT_AREA_CONSTRUCTION: "在建待租",
    WMS_ZONE_FIELD_VACANT_AREA_DUE_TO: "租约到期",
    WMS_ZONE_FIELD_VACANT_AREA_TO_RENT: "可租时间",
    WMS_ZONE_FIELD_VACANT_WAREHOUSE_AREA: "仓库面积",
    WMS_ZONE_FIELD_VACANT_OFFICE_AREA: "独立办公楼面积",
    WMS_ZONE_FIELD_VACANT_SUPPORTING_AREA: "配套楼面积",
    WMS_ZONE_FIELD_VACANT_SUPPORTING_FACILITY: "配套楼功能",
    WMS_ZONE_FIELD_HOPE_IN_TIME: "希望入驻时间",
    WMS_ZONE_FIELD_LEASE_AREA: "可租赁面积",
    WMS_ZONE_FIELD_VACANT_RATE: "空置率",
    WMS_ZONE_FIELD_VACANT_AREA_FLOOR_1: "一层空置面积",
    WMS_ZONE_FIELD_VACANT_AREA_FLOOR_2: "二层级以上空置面积",
    WMS_ZONE_FIELD_VACANT_AREA_FLOOR_SINGLE: "单层仓库空置面积",
    WMS_ZONE_FIELD_VACANT_AREA_FLOOR_DOUBLE: "多层仓库空置面积",
    WMS_ZONE_FIELD_STATUS: "状态",
    WMS_ZONE_FIELD_STATUS_COMPLETED: "已建成",
    WMS_ZONE_FIELD_RADIUS_FIVE: "附近五公里",
    WMS_ZONE_FIELD_RADIUS_TEN: "附近十公里",
    WMS_ZONE_FIELD_RADIUS_FIFTEEN: "附近十五公里",
    WMS_ZONE_FIELD_RADIUS_TWENTY: "附近二十公里",
    WMS_ZONE_FIELD_STATUS_IN_PROGRESS: "在建",
    WMS_ZONE_FIELD_STATUS_IN_PROGRESS_PARTS: "部分在建",

    WMS_ZONE_FIELD_TYPE: "经营类型",
    WMS_ZONE_FIELD_TYPE_BUSINESS: "经营性",
    WMS_ZONE_FIELD_TYPE_SELF: "自用性",

    WMS_ZONE_FIELD_COMPLETION_DATE: "竣工年份",
    WMS_ZONE_FIELD_TAG: "标签",
    WMS_ZONE_FIELD_COMPLETION_DATE_UNKNOWN: "不详",
    WMS_ZONE_FIELD_BUILDING_SUM: "栋数",
    WMS_ZONE_FIELD_RENT: "租金",
    WMS_ZONE_FIELD_SHARE_RATE: "公摊率",
    WMS_ZONE_FIELD_SHARE_RATE_FLAG: "待定",

    WMS_ZONE_FIELD_RENT_RANGE: "租金报价区间",
    WMS_ZONE_FIELD_RENT_MIN: "租金最低报价",
    WMS_ZONE_FIELD_RENT_MIN_PLACEHOLDER: "最低",
    WMS_ZONE_FIELD_RENT_MAX: "租金最高报价",
    WMS_ZONE_FIELD_RENT_MAX_PLACEHOLDER: "最高",
    WMS_ZONE_FIELD_RENT_UNIT: "租金报价单位",
    WMS_ZONE_FIELD_RENT_UNIT_DAY: "元/平方米/天",
    WMS_ZONE_FIELD_RENT_UNIT_MONTH: "元/平方米/月",
    WMS_ZONE_FIELD_RENT_UNIT_YEAR: "元/平方米/年",
    WMS_ZONE_FIELD_RENT_TAX_TYPE: "租金报价税类型",
    WMS_ZONE_FIELD_RENT_TAX_TYPE_TAX_INCLUDE: "含税",
    WMS_ZONE_FIELD_RENT_TAX_TYPE_TAX_FREE: "不含税",
    WMS_ZONE_FIELD_RENT_TAX_PROPERTY_TYPE_TAX_INCLUDE: "含税含物业",
    WMS_ZONE_FIELD_RENT_TAX_PROPERTY_TYPE_TAX_FREE: "不含税含物业",
    WMS_ZONE_FIELD_RENT_TAX_RATE: "租金报价税点",
    WMS_ZONE_FIELD_RENT_PROPERTY_TYPE: "租金报价物业类型",
    WMS_ZONE_FIELD_RENT_PROPERTY_TYPE_INCLUDE: "含物业",
    WMS_ZONE_FIELD_RENT_PROPERTY_TYPE_FREE: "不含物业",
    WMS_ZONE_FIELD_RENT_INCREASE: "租金增幅",
    WMS_ZONE_FIELD_RENT_FREE: "免租期",
    WMS_ZONE_FIELD_ENTRY_FREE: "提前进场",
    WMS_ZONE_FIELD_RENT_FREE_CONDITION: "年免",
    WMS_ZONE_FIELD_RENT_NEGOTIABLE: "(面议)",
    WMS_ZONE_FIELD_RENT_FREE_PERIOD: "个月",
    WMS_ZONE_FIELD_RENT_FREE_BUILDING: "栋",
    WMS_ZONE_FIELD_RENT_LAND_DEED: "张土地证",
    WMS_ZONE_FIELD_PROPERTY_FEE: "物业费",
    WMS_ZONE_FIELD_PROPERTY_FEE_UNIT: "物业费单位",
    WMS_ZONE_FIELD_RENTAL_AREA_MIN: "起租面积",
    WMS_ZONE_FIELD_RENTAL_AREA_UNIT_MIN: "最小出租单元面积",
    WMS_ZONE_FIELD_RENT_PROPERTY_SPLIT: "租金物业拆分",
    WMS_ZONE_FIELD_RENT_PROPERTY_SPLIT_RENT: "租金",
    WMS_ZONE_FIELD_RENT_PROPERTY_SPLIT_PROPERTY: "物业费",
    WMS_ZONE_FIELD_RENT_PROPERTY_SPLIT_TYPE: "租金物业调整",
    WMS_ZONE_FIELD_RENT_PROPERTY_SPLIT_TYPE_ADJUST: "调整",
    WMS_ZONE_FIELD_RENT_PROPERTY_SPLIT_TYPE_NO_ADJUST: "不调整",

    WMS_ZONE_FIELD_RENT_PROPERTY_SPLIT_TYPE_SPLIT: "拆分",
    WMS_ZONE_FIELD_RENT_PROPERTY_SPLIT_TYPE_NO_SPLIT: "不拆分",
    WMS_INTENTION_LETTER_FIELD_HEADER_FLAG_HAS: "带页眉页脚",
    WMS_INTENTION_LETTER_FIELD_HEADER_FLAG_NO: "不带页眉页脚",

    WMS_ZONE_FIELD_RENT_PROPERTY_SPLIT_TYPE_UNKNOWN: "不详",
    WMS_ZONE_FIELD_LESSOR_COMPANY: "出租方公司",
    WMS_ZONE_FIELD_LESSOR_CONTACT: "出租方联系人",
    WMS_ZONE_FIELD_ZONE_PHOTO: "房源照片",
    WMS_ZONE_FIELD_ZONE_PHOTO_TAG: "房源照片标签",
    WMS_ZONE_FIELD_ZONE_PHOTO_MAIN_FLAG: "是否主图",
    WMS_ZONE_FIELD_SELLING_POINT_PLACEHOLDER: "请输入房源卖点",
    WMS_ZONE_FIELD_SELLING_POINT: "房源卖点",
    WMS_ZONE_FIELD_CUSTOM_PPT: "单项PPT",

    WMS_ZONE_FIELD_ZONE_PHOTO_ACTIVE_FLAG: "是否激活",
    WMS_ZONE_FIELD_ZONE_PHOTO_UPLOAD_TIME: "上传时间",

    WMS_ZONE_FIELD_ZONE_DRAWINGS_AND_PHOTO: "图纸及证照",
    WMS_ZONE_FIELD_ZONE_FILE_TAG: "标签",
    WMS_ZONE_FIELD_ZONE_FILE_ACTIVE_FLAG: "是否激活",
    WMS_ZONE_FIELD_POWER_DISTRIBUTION: "配电",
    WMS_ZONE_MSG_SAVE_ZONE_WARNING: "请保存项目",
    WMS_ZONE_MSG_BUILDINGS_CREATE_WARNING_CONTENT: "物业创建之前，请先保存项目",
    WMS_ZONE_MSG_LEASES_CREATE_WARNING_CONTENT: "租约创建之前，请先保存项目",
    WMS_ZONE_MSG_CONTACT_SELECT_WARNING_CONTENT: "选择联系人之前，请先保存项目",
    WMS_ZONE_MSG_RENT_CORRECT: "有效租金过高，请确认租金报价区间，和租金报价单位",
    WMS_LEASE_MSG_RENT_CORRECT: "当前租金过高，请确认初始租金，和租金单位",
    // 我的房源收藏
    WMS_ZONE_FAVORITES_MSG_EXIST: "该房源已收藏",
    WMS_ZONE_FAVORITES_MSG_MAX_LIMIT: "我的房源收藏限定在30个以内",
    WMS_ZONE_TITLE_EDIT_PPT: "房源单项编辑",

    WMS_LEASE_TITLE_CALCULATION: "租金计算器",

    // 房源物业管理
    WMS_BUILDING_FIELD_NUMBER: "物业编号",
    WMS_BUILDING_FIELD_ZONE: "所属项目",
    WMS_BUILDING_FIELD_TYPE: "建筑类型",
    WMS_BUILDING_FIELD_TYPE_SINGLE: "单层库",
    WMS_BUILDING_FIELD_TYPE_MULTI_RAMP: "多层坡道库",
    WMS_BUILDING_FIELD_TYPE_MULTI_ELEVATOR: "多层电梯库",
    WMS_BUILDING_FIELD_TYPE_FLAT: "平库",
    WMS_BUILDING_FIELD_TYPE_WORKSHOP: "厂房",
    WMS_BUILDING_FIELD_TYPE_MULTI_ELEVATOR_RAMP: "多层电梯坡道库",
    WMS_BUILDING_FIELD_FLOOR_SUM: "层数",
    WMS_BUILDING_FIELD_FLOOR_HEIGHT: "{sum} 层净高",
    WMS_BUILDING_FIELD_FLOOR_LOAD: "{sum} 层荷载",
    WMS_BUILDING_FIELD_FIRE_FACILITIES: "消防设施",
    WMS_BUILDING_FIELD_FIRE_FACILITIES_ESFR: "ESFR快速喷淋",
    WMS_BUILDING_FIELD_FIRE_FACILITIES_BUBBLE: "消防水泡",
    WMS_BUILDING_FIELD_FIRE_FACILITIES_HYDRANT: "消防栓",
    WMS_BUILDING_FIELD_FIRE_RATING: "耐火等级",
    WMS_BUILDING_FIELD_FIRE_RATING_CLASS_C2: "丙-2类",
    WMS_BUILDING_FIELD_FIRE_RATING_CLASS_C: "丙类",
    WMS_BUILDING_FIELD_FIRE_RATING_CLASS_C1: "丙-1类",
    WMS_BUILDING_FIELD_FIRE_RATING_CLASS_D: "丁类",
    WMS_BUILDING_FIELD_FIRE_RATING_CLASS_B: "乙类",
    WMS_BUILDING_FIELD_FIRE_RATING_CLASS_A: "甲类",
    WMS_BUILDING_FIELD_PLATFORM_FLAG: "月台有无",
    WMS_BUILDING_FIELD_PLATFORM_FLAG_HAS: "有月台",
    WMS_BUILDING_FIELD_PLATFORM_FLAG_NO: "无月台",

    WMS_BUILDING_FIELD_PLATFORM_TYPE: "月台类型",
    WMS_BUILDING_FIELD_PLATFORM_TYPE_INSIDE: "内置式",
    WMS_BUILDING_FIELD_PLATFORM_TYPE_OUTSIDE: "外置式",
    WMS_BUILDING_FIELD_PLATFORM_HEIGHT: "月台高度",
    WMS_BUILDING_FIELD_PLATFORM_WIDTH: "月台宽度",
    WMS_BUILDING_FIELD_TRAIN_WORKING: "行车",
    WMS_BUILDING_FIELD_SUPPORTING_FACILITY: "配套设施",
    WMS_BUILDING_FIELD_SUPPORTING_FACILITY_DORMITORY: "宿舍",
    WMS_BUILDING_FIELD_SUPPORTING_FACILITY_CANTEEN: "食堂",
    WMS_BUILDING_FIELD_SUPPORTING_FACILITY_FLAG: "配套设施有无",
    WMS_BUILDING_FIELD_TAX_REQUIREMENTS: "落税要求",
    WMS_BUILDING_FIELD_TAX_REQUIREMENTS_MANDATORY: "强制落税",
    WMS_BUILDING_FIELD_TAX_REQUIREMENTS_NO_MANDATORY: "无强制要求",
    WMS_BUILDING_FIELD_TAX_REQUIREMENTS_UNKNOWN: "不详",
    WMS_BUILDING_FIELD_BUSINESS_TYPE: "仓库属性",
    WMS_BUILDING_FIELD_BUSINESS_TYPE_GENERAL: "普货仓",
    WMS_BUILDING_FIELD_BUSINESS_TYPE_BONDED: "保税库",
    WMS_BUILDING_FIELD_BUSINESS_TYPE_COLD: "冷库",
    WMS_BUILDING_FIELD_BUSINESS_TYPE_DANGEROUS: "危险品库",
    WMS_BUILDING_FIELD_LICENSE: "证照",
    WMS_BUILDING_FIELD_LICENSE_LAND: "土地证",
    WMS_BUILDING_FIELD_LICENSE_PROJECT: "工程规划许可证",
    WMS_BUILDING_FIELD_LICENSE_BUILDER: "施工许可证",
    WMS_BUILDING_FIELD_LICENSE_HOUSE: "房产证",
    WMS_BUILDING_FIELD_UNLOADING_TYPE: "卸货方式",
    WMS_BUILDING_FIELD_UNLOADING_TYPE_SINGLE: "单面",
    WMS_BUILDING_FIELD_UNLOADING_TYPE_DOUBLE: "双面",
    WMS_BUILDING_FIELD_UNLOADING_TYPE_MULTI: "多面",
    WMS_BUILDING_FIELD_BUILDING_AREA: "建筑面积",
    WMS_BUILDING_FIELD_VACANT_AREA: "空置面积",
    WMS_BUILDING_FIELD_VACANCY_RATE: "空置率",
    WMS_BUILDING_FIELD_TURNOVER_AREA: "周转场地",
    WMS_BUILDING_FIELD_COLUMN_NET_WIDTH: "{sum}层柱网宽",
    WMS_BUILDING_FIELD_COLUMN_NET_HEIGHT: "{sum}层柱网深",
    WMS_BUILDING_FIELD_LONGITUDE: "经度",
    WMS_BUILDING_FIELD_LATITUDE: "纬度",
    WMS_BUILDING_FIELD_COOPERATION_TYPE: "合作类型",
    WMS_BUILDING_FIELD_COOPERATION_TYPE_PURE_WAREHOUSE: "纯租仓",
    WMS_BUILDING_FIELD_COOPERATION_TYPE_WAREHOUSE_MANAGER: "可提供租仓+仓储管理服务",
    WMS_BUILDING_FIELD_COOPERATION_TYPE_OUTSOURCE: "必须托管/外包",

    // 租约管理
    WMS_LEASE_FIELD_LESSEE_COMPANY_NAME: "租户",
    WMS_LEASE_FIELD_LESSEE_COMPANY_TYPE: "租户类型",
    WMS_LEASE_FIELD_TERMINAL_COMPANY_NAME: "终端用户",
    WMS_LEASE_FIELD_TERMINAL_COMPANY_TYPE: "终端商品类型",
    WMS_LEASE_FIELD_THIRD_COMPANY_NAME: "第三方公司",
    WMS_LEASE_FIELD_TRADER_TYPE: "成交人类型",
    WMS_LEASE_FIELD_TRADER_TYPE_EMPLOYEE: "本公司",
    WMS_LEASE_FIELD_TRADER_TYPE_OWNER: "业主直租",
    WMS_LEASE_FIELD_TRADER_TYPE_THIRD: "其他第三方中介",
    WMS_LEASE_FIELD_TRADER_USER: "成交人",
    WMS_LEASE_FIELD_TRADER_USER_PLACEHOLDER: "用户选择",
    WMS_LEASE_FIELD_AREA: "租赁面积",
    WMS_LEASE_FIELD_TIME: "租赁期限",
    WMS_LEASE_FIELD_STATUS: "租赁状态",
    WMS_LEASE_FIELD_CURRENT: "当前租约",
    WMS_LEASE_FIELD_HISTORY: "历史租约",
    WMS_LEASE_FIELD_CURRENT_RENT: "当前租金",
    WMS_LEASE_FIELD_RENT_REMARK: "租金备注",

    WMS_LEASE_FIELD_START_DATE: "租赁开始日",

    WMS_LEASE_FIELD_END_DATE: '租赁结束日',
    WMS_LEASE_FIELD_RENT: '初始租金',
    WMS_LEASE_FIELD_RENT_UNKNOWN: "不详",

    WMS_LEASE_FIELD_RENT_UNIT: '租金单位',
    WMS_LEASE_FIELD_RENT_TAX_TYPE: '租金税类型',
    WMS_LEASE_FIELD_RENT_TAX_RATE: '租金税点',
    WMS_LEASE_FIELD_RENT_INCREASE: '租金增幅',
    WMS_LEASE_FIELD_RENT_FREE: '免租期',
    WMS_LEASE_FIELD_RENT_FREE_CONDITION: '年免',
    WMS_LEASE_FIELD_RENT_FREE_PERIOD: "个月",
    WMS_LEASE_FIELD_ENTRY_FREE: "提前进场",
    WMS_LEASE_FIELD_ENTRY_FREE_CONDITION: '年给予',
    WMS_LEASE_FIELD_ENTRY_FREE_PERIOD: '个月',
    WMS_LEASE_FIELD_RENT_PROPERTY_TYPE: "物业类型",
    WMS_LEASE_FIELD_PROPERTY_FEE: "物业费",
    WMS_LEASE_FIELD_PROPERTY_FEE_UNIT: "物业费单位",
    WMS_LEASE_FIELD_ADJUST_RENT: '调整租金',

    // 租户管理
    WMS_LESSEE_ROUTE_MANAGEMENT: "租户管理",
    WMS_LESSEE_ROUTE_BRAND_LIST: "租户品牌",
    WMS_LESSEE_ROUTE_COMPANY_LIST: "租户公司",
    WMS_LESSEE_ROUTE_CONTACT_LIST: "租户联系人",

    WMS_LESSEE_CREATE_LESSEE_COMPANY: "新建租户公司",
    WMS_LESSEE_CREATE_LESSEE_BRAND: "新建品牌",
    WMS_LESSEE_COMPANY_LESSEE_MESSAGE: "请填写准确、完整的租户公司法律主体名称。",
    WMS_LESSEE_COMPANY_NAME: "租户名称",
    WMS_LESSEE_COMPANY_CATEGORY: "租户分类",
    WMS_LESSEE_COMPANY_TYPE: "租户类型",
    WMS_LESSEE_COMPANY_TERMINAL_NAME: "终端用户名称",
    WMS_LESSEE_COMPANY_TERMINAL_TYPE: "终端用户商品类型",
    WMS_LESSEE_COMPANY_TITLE_CREATE: "租户创建",
    WMS_LESSEE_COMPANY_TITLE_UPDATE: "租户更新",
    WMS_LESSEE_COMPANY_DELETE: "租户删除",
    WMS_LESSEE_COMPANY_COMMERCE: "电商",
    WMS_LESSEE_COMPANY_PL: "3PL",
    WMS_LESSEE_COMPANY_MANUFACTURING: "生产制造",
    WMS_LESSEE_COMPANY_RETAIL: "零售",
    WMS_LESSEE_COMPANY_EXPRESS: "快递快运",
    WMS_LESSEE_COMPANY_HEAD_LESSEE: "二房东",
    WMS_LESSEE_COMPANY_COLD_CHAIN: "冷链",
    WMS_COMPANY_FIELD_HIGH_FREQUENCY_TRUE: "高频品牌",
    WMS_COMPANY_FIELD_HIGH_FREQUENCY_FALSE: "低频租户",

    //租约的终端商品
    WMS_LESSEE_TERMINAL_GOODS_TYPE_DAILY_CONSUMABLES: "日用快消品",
    WMS_LESSEE_TERMINAL_GOODS_TYPE_MEDICAL_INSTRUMENTS: "药品及医疗器械",
    WMS_LESSEE_TERMINAL_GOODS_TYPE_FOOD: "食品(含饮料及低度酒)",
    WMS_LESSEE_TERMINAL_GOODS_TYPE_AUTO_PARTS: "汽车零配件",
    WMS_LESSEE_TERMINAL_GOODS_TYPE_CLOTHING: "衣帽鞋服",
    WMS_LESSEE_TERMINAL_GOODS_TYPE_LARGE_HOUSEHOLD_APPLIANCES: "大家电(空调、冰箱、洗衣机等)",
    WMS_LESSEE_TERMINAL_GOODS_TYPE_SMALL_HOME_APPLIANCES: "小家电",
    WMS_LESSEE_TERMINAL_GOODS_TYPE_MECHANICAL_EQUIPMENT: "机械设备",
    WMS_LESSEE_TERMINAL_GOODS_TYPE_FRESH_VEGETABLE_FRUIT: "生鲜蔬果",
    WMS_LESSEE_TERMINAL_GOODS_TYPE_ELECTRONIC_COMPONENTS: "电子元器件",
    WMS_LESSEE_TERMINAL_GOODS_TYPE_INDUSTRIAL_PRODUCTS: "工业制品",
    WMS_LESSEE_TERMINAL_GOODS_TYPE_COSMETICS: "化妆品",
    WMS_LESSEE_TERMINAL_GOODS_TYPE_STEEL: "钢材及铝制品",
    WMS_LESSEE_TERMINAL_GOODS_TYPE_FURNITURE: "家具",
    WMS_LESSEE_TERMINAL_GOODS_TYPE_LIQUOR: "酒精及高度酒",
    WMS_LESSEE_TERMINAL_GOODS_TYPE_LUBRICATING_OIL_PAINT: "润滑油及油漆",
    WMS_LESSEE_TERMINAL_GOODS_TYPE_DANGEROUS_GOODS: "危险品及化工",
    WMS_LESSEE_TERMINAL_GOODS_TYPE_RUBBER: "轮胎及橡胶制品",
    // 出租人管理
    WMS_LESSOR_ROUTE_MANAGEMENT: "出租方管理",
    WMS_LESSOR_ROUTE_BRAND_LIST: "出租方品牌",
    WMS_LESSOR_ROUTE_COMPANY_LIST: "出租方公司",
    WMS_LESSOR_ROUTE_CONTACT_LIST: "出租方联系人",

    WMS_LESSOR_COMPANY_LESSOR_MESSAGE: "请填写准确、完整的出租方公司法律主体名称。",
    WMS_LESSOR_COMPANY_TITLE_CREATE: "出租方创建",
    WMS_LESSOR_COMPANY_TITLE_UPDATE: "出租方更新",
    WMS_LESSOR_COMPANY_TITLE_DELETE: "出租方删除",
    WMS_LESSOR_COMPANY_FIELD_BRAND_ID: "品牌",
    WMS_LESSOR_COMPANY_FIELD_LEASE_STATE: "租赁状态",
    WMS_LESSOR_COMPANY_FIELD_NAME: "名称",
    WMS_LESSOR_COMPANY_FIELD_CONTACT_NAME: "联系人",
    WMS_LESSOR_COMPANY_FIELD_CONTACT_PHONE: "联系电话",
    WMS_LESSOR_COMPANY_FIELD_CONTACT: "联系人详情",
    WMS_LESSOR_COMPANY_FIELD_CONTACT_LIST: "联系人一览",
    WMS_BUILDING_MSG_NAME_IN_USE: "该名称已被使用",


    // 品牌管理
    WMS_BRAND_ROUTE_LIST: "品牌方一览",
    WMS_BRAND_TITLE_CREATE: "品牌方创建",
    WMS_BRAND_TITLE_UPDATE: "品牌方更新",
    WMS_BRAND_TITLE_DELETE: "品牌方删除",
    WMS_BRAND_FIELD_NAME_ZH_1: "中文名称1",
    WMS_BRAND_FIELD_NAME_ZH_2: "中文名称2",
    WMS_BRAND_FIELD_NAME_EN_1: "英文名称1",
    WMS_BRAND_FIELD_NAME_EN_2: "英文名称2",

    WMS_LESSOR_MSG_DELETE_CONFIRM: "确认要删除出租方吗？",
    WMS_LESSOR_MSG_CREATE_SUCCESS: "出租方创建成功",
    WMS_LESSOR_MSG_UPDATE_SUCCESS: "出租方更新成功",
    WMS_LESSOR_DELETE_SUCCESS: "出租方删除成功",

    // 出租方联系人
    WMS_LESSOR_CONTACT_FIELD_NAME: "联系人",
    WMS_LESSOR_CONTACTS_TITLE_CREATE: "联系人创建",
    WMS_LESSOR_CONTACTS_TITLE_UPDATE: "联系人更新",
    WMS_LESSOR_CONTACTS_TITLE_DELETE: "联系人删除",
    WMS_LESSOR_CONTACT_FIELD_PHONE: "联系电话",
    WMS_LESSOR_CONTACT_FIELD_POSITION: "联系人职位",
    WMS_LESSOR_CONTACT_FIELD_MAIN_FLAG: "主联系人",
    WMS_LESSOR_CONTACT_TITLE_CREATE: "出租方联系人创建",
    WMS_LESSOR_CONTACT_TITLE_UPDATE: "出租方联系人更新",
    // 联系人一览z-index
    WMS_CONTACTS_TITLE_CREATE: "联系人创建",
    WMS_CONTACTS_TITLE_UPDATE: "联系人更新",
    WMS_CONTACTS_TITLE_DELETE: "联系人删除",
    WMS_CONTACTS_FIELD_NAME: "联系人",
    WMS_CONTACTS_FIELD_PHONE: "联系电话",
    WMS_CONTACTS_FIELD_EMAIL: "邮箱",
    WMS_CONTACTS_FIELD_POSITION: "联系人职位",
    WMS_CONTACTS_FIELD_REGION: "管理区域",
    WMS_CONTACTS_FIELD_POSITION_LEASING_MANAGER: "租赁经理（项目租赁）",
    WMS_CONTACTS_FIELD_POSITION_LEASING_DIRECTOR: "租赁总监（区域租赁负责人）",
    WMS_CONTACTS_FIELD_POSITION_MANAGER: "管理层",
    WMS_CONTACTS_FIELD_POSITION_LEGAL: "法务",
    WMS_CONTACTS_FIELD_POSITION_PROJECT: "工程及规划",
    WMS_CONTACTS_FIELD_INVESTMENT_DEVELOPMENT: "投资与拓展",
    WMS_CONTACTS_FIELD_ASSET_MANAGEMENT: "资产管理",
    WMS_CONTACTS_FIELD_POSITION_PROCUREMENT: "采购",
    WMS_CONTACTS_FIELD_POSITION_SALES: "销售",
    WMS_CONTACTS_FIELD_POSITION_PLAN_AND_SCHEME: "规划及方案",
    WMS_CONTACTS_FIELD_POSITION_FINANCIAL: "财务",
    WMS_CONTACTS_FIELD_POSITION_OPERATING: "运营",
    WMS_CONTACTS_FIELD_POSITION_ADMINISTRATIVE: "行政",
    WMS_CONTACTS_FIELD_MAIN_FLAG: "主联系人",
    WMS_CONTACTS_FIELD_AREA: "负责区域",
    WMS_CONTACTS_FIELD_BRAND: "品牌",
    WMS_CONTACTS_FIELD_LESSOR: "出租方",
    WMS_CONTACTS_FIELD_TENEMENT: "租户",
    WMS_CONTACTS_COMPANY_FIELD_ZONE_ID: "房源",

    WMS_CONTACTS_FIELD_REGION_EAST: "华东",
    WMS_CONTACTS_FIELD_REGION_SOUTH: "华南",
    WMS_CONTACTS_FIELD_REGION_NORTH: "华北",
    WMS_CONTACTS_FIELD_REGION_CENTRAL: "华中",
    WMS_CONTACTS_FIELD_REGION_SOUTHWEST: "西南",
    WMS_CONTACTS_FIELD_REGION_NORTHWEST: "西北",
    WMS_CONTACTS_FIELD_REGION_NORTHEAST: "东北",


    WMS_CONTACTS_BUTTON_BINDING_ZONE: "关联房源",
    WMS_CONTACTS_TITLE_BINDING_ZONE: "关联房源",
    WMS_CONTACTS_TAB_BINDING_ZONE: "已关联的房源",
    WMS_CONTACTS_TAB_WAIT_BINDING_ZONE: "关联的房源",

    // 方案组
    WMS_PROPOSAL_GROUP_TITLE_SELECT: "方案组选择",
    WMS_PROPOSAL_GROUP_TITLE_CREATE: "方案组新建",
    WMS_PROPOSAL_GROUP_FIELD_NAME: "方案组名称",
    WMS_PROPOSAL_GROUP_FIELD_PUBLISH_FLAG: "发布状态",
    WMS_PROPOSAL_GROUP_FIELD_PUBLISH_TRUE: "已发布",
    WMS_PROPOSAL_GROUP_FIELD_PUBLISH_FALSE: "未发布",
    WMS_PROPOSAL_GROUP_BUTTON_PUBLISH: "发布",
    WMS_PROPOSAL_GROUP_BUTTON_PUBLISH_CANCEL: "取消发布",
    WMS_PROPOSAL_GROUP_MSG_PROPOSAL_ZONE_ID_UNIQUE: "该方案已添加。",
    WMS_PROPOSAL_GROUP_MSG_ONLY_OWNER_DELETE: "只有方案创建人才可以删除",
    WMS_PROPOSAL_GROUP_MSG_NOT_FOUND: "没有方案组",

    // 报价方案
    WMS_PROPOSAL_ROUTE_MANAGEMENT: "方案管理",
    WMS_PROPOSAL_ROUTE_LIST: "方案一览",
    WMS_PROPOSAL_ROUTE_DETAIL: "方案详情",
    WMS_PROPOSAL_ROUTE_COMPARE: "方案比较",
    WMS_PROPOSAL_ROUTE_COMPARE_NEW: "方案比较(新)",
    WMS_PROPOSAL_GROUP_VIEW: "方案比较预览",
    WMS_PROPOSAL_ROUTE_MAP: "地图信息",
    WMS_PROPOSAL_FIELD_GROUP_NAME: "方案组名",
    WMS_PROPOSAL_FIELD_NUMBER: "编号",
    WMS_PROPOSAL_FIELD_NUMBER_PREFIX: "方案",
    WMS_PROPOSAL_FIELD_ZONE_NUMBER: "项目编号",
    WMS_PROPOSAL_FIELD_ZONE_NAME: "项目名称",
    WMS_PROPOSAL_FIELD_ZONE_ADDRESS: "地址",
    WMS_PROPOSAL_FIELD_ZONE_PHOTOS: "项目照片",
    WMS_PROPOSAL_FIELD_NAME: "方案名",
    WMS_PROPOSAL_FIELD_BUILDING_TYPE: "楼层",
    WMS_PROPOSAL_FIELD_BUILDING_AREA: "总建筑面积",
    WMS_PROPOSAL_FIELD_VACANT_AREA: "空置面积",
    WMS_PROPOSAL_FIELD_VACANT_AREA_REMARKS: "备注说明",
    WMS_PROPOSAL_FIELD_QUOTATION: "单价",
    WMS_PROPOSAL_FIELD_QUOTATION_REMARKS: "单价备注",
    WMS_PROPOSAL_FIELD_PLATFORM: "有无月台",
    WMS_PROPOSAL_FIELD_ELEVATOR_TYPE: "电梯",
    WMS_PROPOSAL_FIELD_PLATFORM_HEIGHT: "月台高度",
    WMS_PROPOSAL_FIELD_PLATFORM_WIDTH: "月台宽度",
    WMS_PROPOSAL_FIELD_TURNOVER_AREA: "周转场地",
    WMS_PROPOSAL_FIELD_COLUMN_NET_WIDTH: "柱网宽",
    WMS_PROPOSAL_FIELD_COLUMN_NET_HEIGHT: "柱网深",
    WMS_PROPOSAL_FIELD_FIRE_FACILITIES: "消防设施",
    WMS_PROPOSAL_FIELD_FIRE_RATING: "耐火等级",
    WMS_PROPOSAL_FIELD_FIRE_FACILITIES_RATING: "消防等级",
    WMS_PROPOSAL_FIELD_FLOOR_HEIGHT: "层高",
    WMS_PROPOSAL_FIELD_COLUMN_NET: "柱网",
    WMS_PROPOSAL_FIELD_FLOOR_LOAD: "承重",
    WMS_PROPOSAL_FIELD_UNLOADING_TYPE: "有无卸货场地",
    WMS_PROPOSAL_FIELD_RENTAL_DATA: "可租日期",
    WMS_PROPOSAL_FIELD_TAX_REQUIREMENTS: "落税要求",
    WMS_PROPOSAL_FIELD_TAX_RATE: "税点",
    WMS_PROPOSAL_FIELD_BILL_TYPE: "发票类型",
    WMS_PROPOSAL_FIELD_RENT_FREE_CONDITION: "年免",
    WMS_PROPOSAL_FIELD_RENT_FREE_PERIOD: "个月",
    WMS_PROPOSAL_FIELD_EFFECTIVE_PRICE: "有效价格",
    WMS_PROPOSAL_FIELD_PUBLISH_GROUP_NAME: "方案组名称",
    WMS_PROPOSAL_FIELD_PUBLISH_FLAG: "发布标识",
    WMS_PROPOSAL_FIELD_PUBLISH_TIME: "发布时间",
    WMS_PROPOSAL_TITLE_PREVIEW: "方案预览",
    WMS_PROPOSAL_TITLE_FIELD: "字段预览",
    WMS_PROPOSAL_FIELD_PREVIEW: "单项PPT",
    WMS_PROPOSAL_LINK_IMPROPER: "方案不合适",
    WMS_PROPOSAL_CLASSIFY_INFORMATION: "项目概况",
    WMS_PROPOSAL_CLASSIFY_BUSINESS: "商务信息",
    WMS_PROPOSAL_CLASSIFY_OTHER: "",
    WMS_PROPOSAL_CLASSIFY_SPEC: "建筑规格",

    WMS_PROPOSAL_BUTTON_SORT: "方案排序",
    WMS_PROPOSAL_BUTTON_FIELD_SORT: "字段排序",
    WMS_PROPOSAL_BUTTON_COMPANY_POINT: "公司拾点",
    WMS_PROPOSAL_TITLE_SORT: "方案排序",
    WMS_PROPOSAL_TITLE_DELETE: "方案删除",

    WMS_PROPOSAL_TITLE_BRAND_NAME: "品牌",
    WMS_PROPOSAL_TITLE_DISTANCE: "距离原点",

    // 方案不合适理由
    WMS_PROPOSAL_TITLE_IMPROPER_REASON: "方案不合适",

    WMS_PROPOSAL_FIELD_IMPROPER_REASON: "不合适理由",
    WMS_PROPOSAL_FIELD_IMPROPER_REASON_OTHER: "其他理由",

    WMS_PROPOSAL_IMPROPER_REASON_CODE_POSITION: "位置不合适",
    WMS_PROPOSAL_IMPROPER_REASON_CODE_SPEC: "物业规格不匹配",
    WMS_PROPOSAL_IMPROPER_REASON_CODE_TIME: "交付时间不匹配",
    WMS_PROPOSAL_IMPROPER_REASON_CODE_AREA: "可租赁面积不匹配",
    WMS_PROPOSAL_IMPROPER_REASON_CODE_TAX: "强制注册落税",
    WMS_PROPOSAL_IMPROPER_REASON_CODE_COMPETITOR: "竞争对手关系",
    WMS_PROPOSAL_IMPROPER_REASON_CODE_THIRD_PARTY: "租赁双方已直接/通过第三方对接",
    WMS_PROPOSAL_IMPROPER_REASON_CODE_OTHER: "其他理由",

    // 跟进记录
    WMS_FOLLOWUP_TITLE_CREATE_FOLLOW: "创建跟进",
    WMS_FOLLOWUP_TITLE_MODIFY_FOLLOW: "更新跟进",
    WMS_FOLLOWUP_FIELD_FOLLOW_TIME: "跟进时间",
    WMS_FOLLOWUP_FIELD_FOLLOW_TYPE: "跟进方式",
    WMS_FOLLOWUP_FIELD_FOLLOW_TYPE_PASSIVE: "数据变动",
    WMS_FOLLOWUP_FIELD_FOLLOW_TYPE_ACTIVE: "主动添加",
    WMS_FOLLOWUP_FIELD_FOLLOW_USER_NAME: "跟进者",
    WMS_FOLLOWUP_FIELD_FOLLOW_CONTENT: "跟进内容",
    WMS_FOLLOWUP_FIELD_FOLLOW_WAY: "联系方式",
    WMS_FOLLOWUP_FIELD_FOLLOW_PHONE_QQ: "电话、微信或QQ",
    WMS_FOLLOWUP_FIELD_FOLLOW_EMAIL: "电子邮件",
    WMS_FOLLOWUP_FIELD_FOLLOW_VISIT_FACE: "当面拜访",
    WMS_FOLLOWUP_FIELD_FOLLOW_CONTENT_BUILDING_AREA: "建筑面积：从{source}平方米修改为{target}平方米。",
    WMS_FOLLOWUP_FIELD_FOLLOW_CONTENT_VACANT_AREA: "空置面积：从{source}平方米修改为{target}平方米。",
    WMS_CONTACT_MSG_PHONE_UNIQUE: '联系人手机号不可重复',

    WMS_BUSINESS_OPPORTUNITY_ROUTE_LIST: "商机一览",
    WMS_BUSINESS_OPPORTUNITY_ROUTE_MANAGER: "商机管理",

    WMS_BUSINESS_OPPORTUNITY_ROUTE_CREATE: "商机创建",
    WMS_BUSINESS_OPPORTUNITY_ROUTE_UPDATE: "商机更新",
    WMS_BUSINESS_OPPORTUNITY_ROUTE_PPT_UPDATE: "商机单页PPT更新",
    WMS_BUSINESS_OPPORTUNITY_FIELD_NUMBER: "商机编号",
    WMS_BUSINESS_OPPORTUNITY_FIELD_PPT: "商机单项PPT",
    WMS_BUSINESS_OPPORTUNITY_PPT_BTN: "单页PPT",
    WMS_BUSINESS_OPPORTUNITY_BUTTON_DISCARD: "商机作废",
    WMS_BUSINESS_OPPORTUNITY_TITLE_DISCARD: "商机作废",
    WMS_BUSINESS_OPPORTUNITY_FIELD_DISCARD_REASON: "商机作废理由",

    WMS_BUSINESS_OPPORTUNITY_FIELD_LEASEE_BRAND: "租户品牌",
    WMS_BUSINESS_OPPORTUNITY_FIELD_LEASEE_CONTACT: "租户联系人",
    WMS_BUSINESS_OPPORTUNITY_FIELD_LEASEE_COMPANY: "租户公司",
    WMS_BUSINESS_OPPORTUNITY_FIELD_LEASEE_COMPANY_TYPE: "租户类型",
    WMS_BUSINESS_OPPORTUNITY_FIELD_TERMINAL_COMPANY: "终端用户",
    WMS_BUSINESS_OPPORTUNITY_FIELD_TERMINAL_COMPANY_TYPE: "终端商品类型",
    WMS_BUSINESS_OPPORTUNITY_FIELD_BUSINESS_TYPE: "业务类型",
    WMS_BUSINESS_OPPORTUNITY_FIELD_BUSINESS_TYPE_BIDDING: "招投标",
    WMS_BUSINESS_OPPORTUNITY_FIELD_BUSINESS_TYPE_SELF: "自营业务",

    WMS_BUSINESS_OPPORTUNITY_FIELD_ADDRESS: "位置要求",
    WMS_BUSINESS_OPPORTUNITY_TITLE_SELECT: "商机选择",
    WMS_BUSINESS_OPPORTUNITY_TITLE_IMAGE: "商机画像",
    WMS_BUSINESS_OPPORTUNITY_TITLE_SCHEDULER: "带看",
    WMS_BUSINESS_OPPORTUNITY_TITLE_INTENTION: "意向",

    WMS_BUSINESS_OPPORTUNITY_TITLE_PROPOSAL: "方案",
    WMS_BUSINESS_OPPORTUNITY_TITLE_FACTORY: "工厂拾点",
    WMS_BUSINESS_OPPORTUNITY_TITLE_BUSINESS_PROFILE: "商机画像",
    WMS_BUSINESS_OPPORTUNITY_TITLE_PLANNING_REQUIREMENTS: "规格要求",
    WMS_BUSINESS_OPPORTUNITY_TITLE_PPT_CONFIRM: "生成单页PPT",
    WMS_BUSINESS_OPPORTUNITY_MSG_PPT_CONFIRM: "生成单页PPT后，只能手动修改，商机更新不会同步数据，确定要现在生成吗？",
    WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PLACEHOLDER: "具体理由",
    WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_RESTART_TIME: "重启时间",

    WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_ONE: "找不到合适房源",
    WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_TWO: "无法促成带看",
    WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_TREE: "客户竞标失败",
    WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_FOUR: "客户决定暂缓该商机-暂无重启时间",
    WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_FIVE: "客户决定暂缓该商机-有重启时间",
    WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_SIX: "客户已锁定房源-新房源地址不详",
    WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_SEVEN: "客户已锁定房源-录入租约",
    WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_EIGHT: "客户原址续租-录入租约",
    WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_NINE: "该商机是伪需求",
    WMS_BUSINESS_OPPORTUNITY_DISCARD_REASON_PROBLEM_TEN: "其他",

    WMS_BUSINESS_OPPORTUNITY_FIELD_REQUIREMENT_TYPE: "需求类型",
    WMS_BUSINESS_OPPORTUNITY_FIELD_REQUIREMENT_TYPE_NEW: "新增业务",
    WMS_BUSINESS_OPPORTUNITY_FIELD_REQUIREMENT_TYPE_MOVE: "搬仓业务",
    WMS_BUSINESS_OPPORTUNITY_FIELD_REQUIREMENT_TYPE_RESEARCH: "调研评估",

    WMS_BUSINESS_OPPORTUNITY_FIELD_MAIN_USAGE: "主要用途",
    WMS_BUSINESS_OPPORTUNITY_FIELD_MAIN_USAGE_WAREHOUSE: "物流仓储",
    WMS_BUSINESS_OPPORTUNITY_FIELD_MAIN_USAGE_TRANSFER: "中转及分拨",
    WMS_BUSINESS_OPPORTUNITY_FIELD_MAIN_USAGE_MANUFACTURE: "生产制造",

    WMS_BUSINESS_OPPORTUNITY_FIELD_REQUIREMENT_TAGS: "需求标签",

    WMS_BUSINESS_OPPORTUNITY_FIELD_REQUIREMENT_AREA: "需求面积",
    WMS_BUSINESS_OPPORTUNITY_FIELD_RENT_START_DATE: "最晚起租日期",
    WMS_BUSINESS_OPPORTUNITY_FIELD_RENT_PERIOD: "最短租赁期限",

    WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC: "规格要求",
    WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_FLOOR: "楼层",
    WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_FLOOR_ONLY_SINGLE: "仅单层库",
    WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_FLOOR_ALL: "单层库/坡道库均可",
    WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_FLOOR_GARAGE: "接受楼库",

    WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_FIRE_FACILITIES: "消防设施",
    WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_FIRE_FACILITIES_SPRAY: "必须有喷淋",

    WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_PLATFORM: "月台",
    WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_PLATFORM_HAS: "有月台",
    WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_PLATFORM_NO: "无月台",

    WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_FLOOR_HEIGHT: "层高",
    WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_UPLOADING: "荷载",
    WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_SUPPORTING_FACILITY: "配套设施",
    WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_SUPPORTING_FACILITY_DORMITORY: "必须有宿舍",
    WMS_BUSINESS_OPPORTUNITY_FIELD_SPEC_OTHER: "其他描述",

    WMS_BUSINESS_OPPORTUNITY_FIELD_REFERENCE_LANDMARKS: "参考地标",

    WMS_BUSINESS_OPPORTUNITY_FIELD_GRADE: "商机等级",
    WMS_BUSINESS_OPPORTUNITY_FIELD_GRADE_1: "1类等级",
    WMS_BUSINESS_OPPORTUNITY_FIELD_GRADE_2: "2类等级",
    WMS_BUSINESS_OPPORTUNITY_FIELD_GRADE_3: "3类等级",

    WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS: "商机状态",
    WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_NEW: "新创建",
    WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_IN_PROPOSAL: "配盘中",
    WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_IN_COMMUNICATE: "沟通中",
    WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_IN_SCHEDULE: "带看中",
    WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_IN_INTENTION: "意向中",
    WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_IN_CONTRACT: "合约中",
    WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_IN_RECEIVE: "收佣中",
    WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_COMPLETED: "已成交",
    WMS_BUSINESS_OPPORTUNITY_FIELD_NAME: "名称",
    WMS_BUSINESS_OPPORTUNITY_FIELD_SCALE: "分级",
    WMS_BUSINESS_OPPORTUNITY_FIELD_FOLLOW_UP: "跟进",
    WMS_BUSINESS_OPPORTUNITY_FIELD_AREA: "区域",
    WMS_BUSINESS_OPPORTUNITY_FIELD_STATE: "状态",

    WMS_BUSINESS_OPPORTUNITY_FIELD_UNLIMITED: "不限",
    WMS_BUSINESS_OPPORTUNITY_FIELD_MAIN_FOLLOW_UP: "主跟进",
    WMS_BUSINESS_OPPORTUNITY_FIELD_ASSIST_FOLLOW_UP: "协助跟进",
    WMS_BUSINESS_OPPORTUNITY_FIELD_LESSEE_OR_NAME: "商机编号/租户/终端用户名/租户品牌",

    WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_POSTPONED: "商机暂缓",
    WMS_BUSINESS_OPPORTUNITY_FIELD_STATUS_LOST: "商机丢失",

    WMS_BUSINESS_OPPORTUNITY_BTN_CREATE_LESSEE_COMPANY: "新建租户公司",
    WMS_BUSINESS_OPPORTUNITY_BTN_CREATE_LESSEE_BRAND: "新建品牌",
    WMS_BUSINESS_OPPORTUNITY_FIELD_FOLLOWERS: "跟进人",
    WMS_BUSINESS_OPPORTUNITY_FIELD_FOLLOWERS_NAME: "跟进人",


    WMS_BUSINESS_OPPORTUNITY_CLASSIFY_BUSINESS_PROFILE: "商机画像",
    WMS_BUSINESS_OPPORTUNITY_CLASSIFY_PLANNING_REQUIREMENTS: "规格要求",
    WMS_BUSINESS_OPPORTUNITY_CLASSIFY_OTHER: "",

    WMS_BUSINESS_SCHEDULER_FIELD_GUIDE: "带看人",
    WMS_BUSINESS_SCHEDULER_FIELD_DATE: "带看日期",
    WMS_BUSINESS_SCHEDULER_FIELD_TIME: "带看时间",

    WMS_BUSINESS_SCHEDULER_FIELD_PROPOSAL_NUMBER: "方案编号",
    WMS_BUSINESS_SCHEDULER_FIELD_PROPOSAL_ZONE_NUMBER: "方案&项目编号",
    WMS_BUSINESS_SCHEDULER_FIELD_ZONE_NUMBER: "项目编号",
    WMS_BUSINESS_SCHEDULER_FIELD_BRAND_NAME: "品牌",
    WMS_BUSINESS_SCHEDULER_FIELD_ZONE_NAME: "项目名称",
    WMS_BUSINESS_SCHEDULER_FIELD_ZONE_ADDRESS: "项目地址",
    WMS_BUSINESS_SCHEDULER_FIELD_ZONE_MESSAGE: "项目信息",
    WMS_BUSINESS_SCHEDULER_FIELD_ZONE_INFO: "带看房源",

    WMS_BUSINESS_SCHEDULER_FIELD_GUIDE_PLACEHOLDER: "选择跟进人",

    WMS_BUSINESS_SCHEDULER_FIELD_VIEW_TYPE: "带看类型",
    WMS_BUSINESS_SCHEDULER_FIELD_VIEW_TYPE_ON_SITE: "现场带看",
    WMS_BUSINESS_SCHEDULER_FIELD_VIEW_TYPE_REMOTE: "远程带看",

    WMS_BUSINESS_SCHEDULER_FIELD_SUMMARY: "带看总结",
    WMS_BUSINESS_SCHEDULER_TITLE_SCHEDULER: "带看日程表",
    WMS_BUSINESS_SCHEDULER_TITLE_ZONE_CONTACTS: "联系人管理",

    WMS_BUSINESS_SCHEDULER_ITEM_FIELD_ZONE: "带看房源",

    WMS_BUSINESS_SCHEDULER_ITEM_FIELD_START_TIME: "开始时间",
    WMS_BUSINESS_SCHEDULER_ITEM_FIELD_END_TIME: "结束时间",
    WMS_BUSINESS_SCHEDULER_ITEM_FIELD_CONTACTS: "联系人",
    WMS_BUSINESS_SCHEDULER_ITEM_FIELD_CONTACTS_NAME: "联系人",
    WMS_BUSINESS_SCHEDULER_ITEM_FIELD_CONTACTS_EMAIL: "联系人邮箱",
    WMS_BUSINESS_SCHEDULER_ITEM_FIELD_LAST_SEND_TIME: "最后发送时间",

    WMS_BUSINESS_SCHEDULER_ITEM_FIELD_CONTACTS_PHONE: "联系方式",
    WMS_BUSINESS_SCHEDULER_ITEM_FIELD_REMARKS: "描述备注",
    WMS_BUSINESS_SCHEDULER_ITEM_FIELD_ZONE_PLACEHOLDER: "选择房源",
    WMS_BUSINESS_SCHEDULER_ITEM_TITLE_ZONE_SELECT: "选择带看房源",
    WMS_BUSINESS_SCHEDULER_BUTTON_NOTICE: "项目报备",
    WMS_BUSINESS_SCHEDULER_BUTTON_NOTICE_EMAIL_PREVIEW: "报备邮件",

    WMS_BUSINESS_SCHEDULER_FIELD_EMAIL_FROM: "邮件发送人",
    WMS_BUSINESS_INTENTION_BUTTON_LETTER: "意向书",
    WMS_BUSINESS_SCHEDULER_FIELD_ZONE_CONTACTS_EMAIL_FILL: "业主联系人邮箱补充",

    WMS_BUSINESS_FEEDBACK_FIELD_CONTENT: "反馈信息",
    WMS_BUSINESS_FEEDBACK_FIELD_FEEDBACK_USER: "反馈人",
    WMS_BUSINESS_FEEDBACK_FIELD_FEEDBACK_TIME: "反馈时间",

    //数据汇总
    WMS_SUMMARY_ROUTE_MANAGEMENT: "数据汇总",
    WMS_SUMMARY_ROUTE_DISTRICT: "子市场汇总",
    WMS_SUMMARY_ROUTE_ZONE: "子市场汇总",
    WMS_SUMMARY_ROUTE_AREA: "区域汇总",
    WMS_SUMMARY_ROUTE_FOLLOW: "市场调研汇总",
    WMS_SUMMARY_ROUTE_MAIL: "房源跟进汇总",
    WMS_SUMMARY_FIELD_RESEARCH_REPORT_NUMBER: "市场调研编号",
    WMS_SUMMARY_FIELD_FINISH_TIME: "完成日期",
    WMS_SUMMARY_FIELD_MAINTENANCE_RECORD: "跟进人房源维护记录",
    WMS_SUMMARY_FIELD_FOLLOW_UP: "跟进人",
    WMS_SUMMARY_FIELD_RESEARCH_REPORT_SUM: "参与市场调研报告数",
    WMS_SUMMARY_FIELD_ZONE_SUM: "维护的房源数",
    WMS_SUMMARY_FIELD_SUPERVISOR_EVALUATION: "主管评分",
    WMS_SUMMARY_FIELD_RESEARCH_REPORT_ADDRESS: "调研位置",

    WMS_SUMMARY_FIELD_TIME: "时间",
    WMS_SUMMARY_FIELD_FOLLOW_UP_PEOPLE: "选址顾问",
    WMS_SUMMARY_FIELD_ZONE_NUMBER: "跟进房源",
    WMS_SUMMARY_FIELD_ZONE_PHOTO: "房源照片",
    WMS_SUMMARY_FIELD_CITY: "城市",
    WMS_SUMMARY_FIELD_ZONE_NAME: "项目名称",
    WMS_SUMMARY_FIELD_ZONE_BRAND: "品牌",
    WMS_SUMMARY_FIELD_VACANT_AREA: "空置面积",
    WMS_SUMMARY_FIELD_FOLLOW_UP_TYPE: "跟进内容",

    WMS_SUMMARY_FIELD_CREATE_ZONE_NUM: "新增的房源数量",
    WMS_SUMMARY_FIELD_UPDATE_ZONE_NUM: "修改的房源数量",

    WMS_SUMMARY_FIELD_START_TIME: "开始日期",
    WMS_SUMMARY_FIELD_END_TIME: "结束日期",

    WMS_SUMMARY_ROUTE_DISTRICT_BRAND: "品牌汇总",
    WMS_SUMMARY_FIELD_DISTRICT_TOWN: "行政区/子市场",
    WMS_SUMMARY_FIELD_BRAND_NAME: "品牌",

    WMS_ZONE_FIELD_PROVINCE_CITY: "省份城市",
    MAIL_TITLE_SEND_FORM: "邮件发送",

    MAIL_FIELD_FROM: "From",
    MAIL_FIELD_TO: "To",
    MAIL_FIELD_CC: "Cc",
    MAIL_FIELD_SEND_TIME: "发送时间",
    MAIL_FIELD_SEND_RESULT: "发送结果",

    MAIL_FIELD_TITLE: "邮件标题",
    MAIL_FIELD_CONTENT: "邮件内容",
    MAIL_BUTTON_SEND: "邮件发送",
    MAIL_STATUS_ENUM_NEW: "未发送",
    MAIL_STATUS_ENUM_SUCCESS: "已发送",
    MAIL_STATUS_ENUM_FAILED: "发送失败",
    BASE_ROUTE_MANAGEMENT: "基础信息管理",
    BASE_ROUTE_MAIL_TEMPLATE_LIST: "邮件模版",
    BASE_MAIL_TEMPLATE_TITLE_MODIFY: "模版修改",
    WMS_BUSINESS_SCHEDULER_TITLE_MAIL_HISTORY: "报备邮件发送历史",

    WMS_BUSINESS_OPPORTUNITY_SORT_TYPE_NULL: "默认",
    WMS_BUSINESS_OPPORTUNITY_SORT_TYPE_CUSTOM: "手动调整",
    WMS_BUSINESS_OPPORTUNITY_SORT_TYPE_ASC: "升序",
    WMS_BUSINESS_OPPORTUNITY_SORT_TYPE_DESC: "降序",
    WMS_BUSINESS_OPPORTUNITY_FIELD_DISTANCE: "距离",
    WMS_BUSINESS_OPPORTUNITY_FIELD_RENT: "有效租金",
    WMS_BUSINESS_OPPORTUNITY_FIELD_RENT_AREA_MIN: "起租面积",

    WMS_BUSINESS_OPPORTUNITY_FIELD_VACANT_AREA: "空置面积",
    WMS_BUSINESS_OPPORTUNITY_FIELD_RENTAL_DATE: "可租时间",
    WMS_ZONE_FIELD_CALCULATED_RENT: "计算后租金",
    MAIL_TEMPLATE_CODE_SCHEDULER_ITEM_NOTICE_NO_PRICE_BEFORE: "商机带看-品牌商",
    MAIL_TEMPLATE_CODE_SCHEDULER_ITEM_NOTICE_BEFORE: "商机带看-非品牌商",
    MAIL_TEMPLATE_CODE_SCHEDULER_ITEM_NOTICE_DISCARD_AFTER: "商机带看后-不合适",
    MAIL_TEMPLATE_CODE_SCHEDULER_ITEM_NOTICE_AFTER: "商机带看后-合适",

    MAIL_TEMPLATE_CODE_INTENTION_MATERIAL_FILE: "商机意向-资料",
    MAIL_TEMPLATE_CODE_PROPOSAL_GROUP_SEND: "方案-发送",
    MAIL_TEMPLATE_CODE_SERVICE_CONTRACT_SEND: "服务协议-发送",

    //商机意向
    WMS_BUSINESS_INTENTION_FIELD_FILE_TYPE: "文件类型",
    WMS_BUSINESS_INTENTION_FIELD_FILE_TITLE: "文件名",
    WMS_BUSINESS_INTENTION_FIELD_ZONE_FILE: "房源中文件",

    WMS_BUSINESS_INTENTION_FIELD_FILE_STATUS: "上传状态",
    WMS_BUSINESS_INTENTION_FIELD_FILE_CONFIRM_STATUS: "确认状态",

    //房源文件标签
    WMS_BUSINESS_INTENTION_TYPE_LAND_CERTIFICATE: "土地证",
    WMS_BUSINESS_INTENTION_TYPE_FIRE_CHECK_REPORT: "消防验收意见书",
    WMS_BUSINESS_INTENTION_TYPE_PROJECT_PLAN_CERTIFICATE: "工程规划许可证",
    WMS_BUSINESS_INTENTION_TYPE_PROJECT_WORK_CERTIFICATE: "工程施工许可证",
    WMS_BUSINESS_INTENTION_TYPE_PROJECT_END_REPORT: "竣工验收备案",
    WMS_BUSINESS_INTENTION_TYPE_HOUSE_CERTIFICATE: "房产证（不动产权证书）",
    WMS_BUSINESS_INTENTION_TYPE_ZONE_TOTAL_VIEW: "项目总平面图",
    WMS_BUSINESS_INTENTION_TYPE_ZONE_HORIZONTAL_VERTICAL_VIEW: "房屋平立剖",
    WMS_BUSINESS_INTENTION_TYPE_CAD_DRAWINGS: "CAD图纸",
    WMS_BUSINESS_INTENTION_TYPE_PROJECT_INTRODUCTION: "项目介绍",
    WMS_BUSINESS_INTENTION_TYPE_BUSINESS_LICENSE: "营业执照",
    WMS_BUSINESS_INTENTION_TYPE_ZONE_PHOTO: "项目照片",
    WMS_BUSINESS_INTENTION_TYPE_RENT_AREA_TABLE: "计租面积明细表",
    WMS_BUSINESS_INTENTION_TYPE_SELLING_POINT: "业主卖点",


    WMS_BUSINESS_INTENTION_MATERIAL_STATUS_NO_UPLOAD: "未上传",
    WMS_BUSINESS_INTENTION_MATERIAL_STATUS_WAIT_UPLOAD: "等待上传",
    WMS_BUSINESS_INTENTION_TITLE_INTENTION_DETAIL: "商机意向",
    WMS_BUSINESS_INTENTION_MATERIAL_STATUS_UPLOADED: "已上传",
    WMS_BUSINESS_INTENTION_BUTTON_SEND_EMAIL: "邮件给业主",
    WMS_BUSINESS_SCHEDULER_AFTER_BUTTON_SEND_EMAIL: "带看后邮件给业主",

    WMS_BUSINESS_INTENTION_MATERIAL_CONFIRM_STATUS_NEED_UPLOAD: '需要上传',
    WMS_BUSINESS_INTENTION_MATERIAL_CONFIRM_STATUS_NO_NEED_UPLOAD: '无需上传',
    WMS_BUSINESS_INTENTION_MATERIAL_CONFIRM_STATUS_CONFIRM: '文件确认',
    WMS_BUSINESS_INTENTION_MATERIAL_CONFIRM_STATUS_WAIT_CONFIRM: '等待确认',
    WMS_BUSINESS_INTENTION_MATERIAL_CONFIRM_STATUS_NO_CONFIRM: '文件不符合',
    WMS_BUSINESS_INTENTION_STATUS_NEW: "新建意向",
    WMS_BUSINESS_INTENTION_STATUS_SEND_MAIL: "已发送邮件",

    WMS_INTENTION_LETTER_FIELD_PAY_TYPE_FIRST_PAY: "先付后用",
    WMS_INTENTION_LETTER_FIELD_PAY_TYPE_FIRST_USE: "先用后付",
    WMS_INTENTION_LETTER_FIELD_DELIVERY_CONDITION_KEEP_SAME: "按现状交付",
    WMS_INTENTION_LETTER_FIELD_DELIVERY_CONDITION_REFORM: "需额外改造",
    WMS_INTENTION_LETTER_FIELD_MONEY_FLAG_HAS_MONEY: "付意向金",
    WMS_INTENTION_LETTER_FIELD_MONEY_FLAG_NO_MONEY: "不付意向金",

    // 土地信息管理
    WMS_LAND_ROUTE_MANAGEMENT: "外部数据",
    WMS_LAND_ROUTE_DATA_IMPORT_LIST: "土地检索数据",

    WMS_LAND_FIELD_DATA_IMPORT_NAME: "数据导入",

    WMS_LAND_FIELD_DATA_IMPORT_CITY: "城市",
    WMS_LAND_FIELD_DATA_IMPORT_USE_NATURE: "用地性质",
    WMS_LAND_FIELD_DATA_IMPORT_DISTRICT: "区县",
    WMS_LAND_FIELD_DATA_IMPORT_LOCATION: "土地位置",
    WMS_LAND_FIELD_DATA_IMPORT_PLAN_NATURE: "详细规划",
    WMS_LAND_FIELD_DATA_IMPORT_BUILDING_AREA: "建设用地面积",
    WMS_LAND_FIELD_DATA_IMPORT_VOLUME_RATIO: "容积率",
    WMS_LAND_FIELD_DATA_IMPORT_BUILDING_DENSITY: "建筑密度",
    WMS_LAND_FIELD_DATA_IMPORT_TRADE_DATE: "成交日期",
    WMS_LAND_FIELD_DATA_IMPORT_ANNOUNCEMENT_NO: "公告编号",
    WMS_LAND_FIELD_DATA_IMPORT_TRANSFEREE: "受让单位",
    WMS_LAND_FIELD_DATA_IMPORT_TRANSACTION_PRICE: "成交价(万元)",
    WMS_LAND_FIELD_DATA_IMPORT_TRANSACTION_AMOUNT: "成交每亩价(万元/亩)",
    WMS_LAND_FIELD_DATA_IMPORT_TRANSFER_PERIOD: "出让年份",

    WMS_LAND_FIELD_DATA_IMPORT_USE_INDUSTRIAL_LAND: "工业用地",

    WMS_LAND_FIELD_DATA_IMPORT_DETAILS: "详情",

    WMS_RENT_CALCULATE_NO_NEED_SPLIT: "不需拆分",
    WMS_RENT_CALCULATE_NEED_SPLIT: "需拆分",

    //市场调研管理
    WMS_RESEARCH_REPORT_MANAGEMENT: "市场调研管理",
    WMS_RESEARCH_REPORT_LIST: "市场调研数据",

    WMS_RESEARCH_REPORT_ROUTE_CREATE: "市场调研创建",
    WMS_RESEARCH_REPORT_ROUTE_UPDATE: "市场调研更新",
    WMS_RESEARCH_REPORT_ROUTE_MAP: "地图信息",
    WMS_RESEARCH_REPORT_ROUTE_ZONE_LIST: "房源列表",
    WMS_RESEARCH_REPORT_ROUTE_FINAL_REPORT: "最终报告",

    WMS_RESEARCH_REPORT_TITLE_IMAGE: "市场调研画像",
    WMS_RESEARCH_REPORT_TITLE_REPORT: "市场调研报告",
    WMS_RESEARCH_REPORT_TITLE_SUMMARY: "数据汇总",

    WMS_RESEARCH_REPORT_FIELD_NUMBER: "市场调研编号",
    WMS_RESEARCH_REPORT_FIELD_CHOOSE: "市场调研选择",
    WMS_RESEARCH_REPORT_FIELD_ZONE_NAME: "项目名称",
    WMS_RESEARCH_REPORT_FIELD_ZONE_PHOTO: "方案照片",
    WMS_RESEARCH_REPORT_FIELD_LESSOR_BRAND_CONTACT: "品牌客户联系人",
    WMS_RESEARCH_REPORT_FIELD_LESSOR_BRAND: "委托客户品牌",
    WMS_RESEARCH_REPORT_FIELD_LESSOR_COMPANY: "委托客户公司",
    WMS_RESEARCH_REPORT_FIELD_LESSOR_COMPANY_TYPE: "委托客户类型",
    WMS_RESEARCH_REPORT_FIELD_STATUS: "调研状态",
    WMS_RESEARCH_REPORT_FIELD_STATUS_CONTINUE: "调研中",
    WMS_RESEARCH_REPORT_FIELD_STATUS_COMPLETE: "已完成",
    WMS_RESEARCH_REPORT_FIELD_PURPOSE: "调研目的",

    WMS_RESEARCH_REPORT_FIELD_PURPOSE_INVESTMENT: "投资决策",
    WMS_RESEARCH_REPORT_FIELD_PURPOSE_MARKET: "市场评估",

    WMS_RESEARCH_REPORT_FIELD_ADDRESS: "位置要求",
    WMS_RESEARCH_REPORT_FIELD_REPORT_TIME: "报告交稿时间",
    WMS_RESEARCH_REPORT_FIELD_FOLLOWERS: "跟进人",
    WMS_RESEARCH_REPORT_FIELD_CREATE_LESSOR_BRAND: "新建委托客户品牌",
    WMS_RESEARCH_REPORT_FIELD_CREATE_LESSOR_COMPANY: "新建委托客户公司",
    WMS_RESEARCH_REPORT_FIELD_CREATE_LESSOR_CONTACT: "新建品牌客户联系人",
    WMS_RESEARCH_REPORT_FIELD_SERVICE_TYPE: "服务类型",
    WMS_RESEARCH_REPORT_FIELD_SERVICE_TYPE_ONCE: "单次收费",
    WMS_RESEARCH_REPORT_FIELD_SERVICE_TYPE_MONTH: "包月服务",
    WMS_RESEARCH_REPORT_FIELD_ZONE_NUMBER: "房源编号",
    WMS_RESEARCH_REPORT_FIELD_NUM: "编号",
    WMS_RESEARCH_REPORT_FIELD_BRAND: "业主",
    WMS_RESEARCH_REPORT_FIELD_DISTANCE: "距离圆心(km)",
    WMS_RESEARCH_REPORT_FIELD_NAME: "项目名称",
    WMS_RESEARCH_REPORT_FIELD_BUILDING_AREA: "建筑面积(m²)",
    WMS_RESEARCH_REPORT_FIELD_VACANT_AREA: "空置面积(m²)",
    WMS_RESEARCH_REPORT_FIELD_VACANCY_RATE: "空置率",
    WMS_RESEARCH_REPORT_FIELD_ZONE_STATUS: "当前状态",
    WMS_RESEARCH_REPORT_FIELD_BUILDING_TYPE: "建筑类型",
    WMS_RESEARCH_REPORT_FIELD_RENT: "租金报价(RMB/m²/天)",
    WMS_RESEARCH_REPORT_FIELD_RENT_TAX_TYPE: "含税/不含税",
    WMS_RESEARCH_REPORT_FIELD_RENT_TAX_RATE: "税率",
    WMS_RESEARCH_REPORT_FIELD_RENT_FREE_CONDITION: "免租期",
    WMS_RESEARCH_REPORT_FIELD_RENT_EFFECTIVE: "税后租金报价",
    WMS_RESEARCH_REPORT_FIELD_LEASEE: "主要租户",
    WMS_RESEARCH_REPORT_FIELD_RENT_SUCCESSFUL: "成交净租金(RMB/m²/天)",
    WMS_RESEARCH_REPORT_FIELD_REMAKE: "备注",
    WMS_RESEARCH_REPORT_FIELD_LESSOR_CONTACT_TITLE: "委托客户联系人",
    WMS_RESEARCH_REPORT_FIELD_LESSOR_CONTACT_MANAGE: "客户联系人管理",

    WMS_SUMMARY_CHARTS_FIELD_REGION_NAME: "区域",
    WMS_SUMMARY_CHARTS_FIELD_WAREHOUSE_AREA: "仓库面积 (m2)",
    WMS_SUMMARY_CHARTS_FIELD_WAREHOUSE_SUM: "仓库数量",
    WMS_INTENTION_FIELD_RENT_INVOICE_TYPE: "发票类型",

    WMS_INTENTION_FIELD_RENT_INVOICE_TYPE_HOUSE_RENT: "房屋租赁发票",
    WMS_INTENTION_FIELD_RENT_INVOICE_TYPE_WAREHOUSE_SERVICE: "仓储服务发票",
    WMS_CONTACTS_LESSOR_TAGS_LESSOR: "房东",
    WMS_CONTACTS_LESSOR_TAGS_INTERMEDIARY: "中介",
    WMS_CONTACTS_LESSOR_TAGS_SUBLEASE: "租户转租",
    WMS_CONTACTS_LESSOR_TAGS_MIDDLEMAN_LESSOR: "二房东",
    WMS_CONTACTS_FIELD_LESSOR_TAGS: "标签",
    WMS_CONTRACT_TAGS_SEAL: "盖章版",
    WMS_CONTRACT_TAGS_FINALIZATION: "定稿版",
    WMS_CONTRACT_TAGS_DISCUSS: "讨论稿",
    WMS_CONTRACT_TYPE_LEASE: "租赁合同",
    WMS_CONTRACT_TYPE_SERVICE: "服务合同",
    WMS_CONTRACT_ROUTE_LIST: "合约管理",
    WMS_COMMISSION_ROUTE_LIST: "个人佣金管理",

    WMS_BUSINESS_SERVICE_CONTRACT_TITLE_CONTRACT_INFO: "服务协议信息",
    WMS_BUSINESS_SERVICE_CONTRACT_FIELD_LESSOR_COMPANY: "甲方公司",
    WMS_BUSINESS_SERVICE_CONTRACT_FIELD_LESSEE_COMPANY: "租户公司",

    WMS_BUSINESS_SERVICE_CONTRACT_FIELD_MAIN_COMPANY: "瑞莱博信息",

    WMS_BUSINESS_SERVICE_CONTRACT_FIELD_SERVICE_FEE: "咨询服务费",

    WMS_BUSINESS_SERVICE_CONTRACT_FIELD_STAGE_COUNT: "分期数",


    WMS_BUSINESS_SERVICE_CONTRACT_FIELD_COMPANY_CLASSIFIER_LESSOR: "出租方公司",
    WMS_BUSINESS_SERVICE_CONTRACT_FIELD_COMPANY_CLASSIFIER_LESSEE: "租户公司",


    WMS_ZONE_MSG_PIPELINE_MAP: "百度地图",
    WMS_ZONE_MSG_SATELLITE_MAP: "卫星地图",
    WMS_ZONE_MSG_GOOGLE_MAP: "谷歌地图",

    WMS_BUSINESS_FEE_BILL_STATUS_NO: "未开票",
    WMS_BUSINESS_FEE_BILL_STATUS_YES: "已开票",
    WMS_BUSINESS_FEE_COLLECTION_STATUS_NO: "未回款",
    WMS_BUSINESS_FEE_COLLECTION_STATUS_YES: "已回款",

    // 任务
    WMS_TODO_ROUTE_LIST: "我的任务",
    WMS_TODO_FIELD_EXECUTOR_NAME: "处理人",
    WMS_TODO_FIELD_CONTENT: "计划内容",
    WMS_TODO_FIELD_DEADLINE: "接单截止时间",
    WMS_TODO_BUTTON_NEW_FULL: "新增下一步计划",
    WMS_TODO_BUTTON_NEW: "+ 下一步计划",
    WMS_TODO_STATUS_FIELD_STATUS_ALL: "全部",
    WMS_TODO_STATUS_FIELD_STATUS_WAIT: "未读",
    WMS_TODO_STATUS_FIELD_STATUS_READ: "已读",
    WMS_TODO_STATUS_FIELD_STATUS_ACCEPT: "已接单",
    WMS_TODO_STATUS_FIELD_STATUS_REJECT: "已拒绝",

    WMS_TODO_STATUS_FIELD_STATUS_USELESS: "已失效",
    WMS_TODO_STATUS_ROUTE_LIST:"待完成任务",
    WMS_TODO_FIELD_STATUS:"状态",
    WMS_TODO_FIELD_STATUS_NEW:"新创建",
    WMS_TODO_FIELD_STATUS_ACCEPT:"已接收",
    WMS_TODO_FIELD_STATUS_COMPLETE:"已完成",
    WMS_TODO_FIELD_STATUS_EXPIRE:"已过期",
    WMS_TODO_FIELD_STATUS_REJECT:"已拒绝",
    WMS_TODO_FIELD_TYPE:"类型",
    WMS_TODO_FIELD_TYPE_ALL: "全部",
    WMS_TODO_FIELD_TYPE_FOLLOWUP: "跟进计划",
    WMS_TODO_FIELD_TYPE_CUSTOM:"自定义任务",
    WMS_TODO_FIELD_TYPE_OPPORTUNITY:"商机",
    WMS_TODO_FIELD_TYPE_RESEARCH:"市场调研",
    WMS_TODO_FIELD_TYPE_ZONE:"房源跟进",
    WMS_TODO_FIELD_TYPE_RESEARCH_ZONE:"市场调研房源跟进",

    WMS_TODO_MY_PUBLISH_ROUTE_LIST:"我发布的",
    WMS_TODO_MANAGEMENT_ROUTE:"任务管理",

    WMS_TODO_FIELD_TABLE_NAME: "任务相关",
    WMS_TODO_FIELD_TABLE_NAME_ALL: "全部",
    WMS_TODO_FIELD_TABLE_NAME_FOLLOWUP: "跟进计划",
    WMS_TODO_FIELD_TABLE_NAME_OPPORTUNITY:"商机",
    WMS_TODO_FIELD_TABLE_NAME_RESEARCH:"市场调研",
    WMS_TODO_FIELD_TABLE_NAME_ZONE:"房源跟进",
    WMS_TODO_MY_EXECUTE_ROUTE_LIST:"我的任务",
};
export default zh_CN;